export default {
  domainDirectory: {
    title: "官方域名",
    subtitle: "请通过本页面核对官方入口。点击域名即可复制。",
    available: "个当前可连接",
    loading: "正在读取域名…",
    loadFailed: "域名读取失败",
    retry: "重新加载",
    empty: "暂时没有已启用的域名",
    tapToCopy: "点击复制",
    checking: "正在检测",
    checkingShort: "检测中",
    online: "可连接",
    offline: "连接超时",
    waiting: "等待检测",
    timeout: "超时",
    testAll: "立即测试全部域名",
    updatedEveryFifteenSeconds: "连接状态每 15 秒自动测试一次",
    saveReminder: "建议截图保存本页，避免域名信息丢失",
    copied: "域名已复制",
    names: {
      primary: "主域名",
      chinaAccel: "国内加速",
      secondary: "次级域名",
    },
  },
  nickname: {"edit": "编辑昵称", "hint": "2～20位中文、英文字母、数字或下划线", "saved": "昵称已保存", "taken": "该昵称已被使用", "invalid": "请输入2～20位中文、英文字母、数字或下划线，不可使用官方保留名称", "failed": "保存失败，请重试"},
  common: {
    confirm: "确认",
    cancel: "取消",
    search: "搜索",
    language: "语言",
    pleaseRelogin: "登录已过期，请重新登录",
    developing: "功能正在开发中",
    switched: "已切换",
    currentLanguage: "当前语言",
    selectLanguage: "选择语言",
    loading: "加载中...",
    loadingMore: "加载更多...",
    noMoreData: "没有更多数据了",
    noData: "暂无数据",
    serverUnavailable: "服务器暂时不可用",
    loadFailed: "加载失败",
    requestFailed: "请求失败",
    retry: "点击重试",
    projectName: "PANTA MARKET",
    duplicateSubmission: "请勿重复提交",
    fee: "手续费",
    submit: "提交",
    tip: "提示",
    connecting: "连接中...",
    connectWalletFirst: "请先连接钱包",
    connect: "连接",
    insufficientBalance: "余额不足",
    copyFailed: "复制失败",
    sessionAuthRelogin: "重新登录",
    sessionAuthStay: "保持",
    pager: {
      prevPage: "上一页",
      nextPage: "下一页",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "跳至",
      jumpConfirm: "确定",
    },
  },
  tabbar: {
    home: "首页",
    market: "时间线",
    timeline: "时间线",
    planet: "理财",
    trade: "交易",
    prediction: "AI 事件合约预测",
    createMarket: "创建市场",
    finance: "理财",
    fund: "基金",
    assets: "资产",
    rank: "排行",
    planethistory: "申购记录"
  },
  tradeMenu: {
    contract: "事件合约",
    insurance: "保险",
    spot: "现货",
    flash: "闪兑"
  },
  home: {
    searchPlaceholder: "BTC",
    categoryAll: "全部",
    categoryCrypto: "加密货币",
    categoryCommodity: "商品",
    categoryEquity: "股票",
    categoryForex: "外汇",
    categoryMetal: "贵金属",
    predictionLabel: "涨幅预测",
    rise: "涨",
    fall: "跌",
    viewMoreOptions: "查看更多{n}个选项",
    yes: "是",
    no: "否",
    catCrypto: "加密货币",
    catTech: "科技",
    catMetal: "贵金属",
    catSports: "体育",
    catPolitics: "政治",
    catEntertainment: "娱乐",
    statusHot: "热门",
    statusLive: "进行中",
    statusLocked: "已锁定",
    statusLockedWait: "已锁定，等待结算",
    comingSoon: "敬请期待",
    jouleUnit: "JOULE",
    nowLabel: "现在",
    vs: "VS",
    endAtFallback: "--",
    statusHotEn: "HOT",
    hotBannerTitle: "事件合约",
    homeBanner: {
      s1t1: "基于AI的",
      s1t2: "AstralX核心生态",
      s1cta: "AstralX",
      s2t: "Galaxy基金",
      s2s1: "了解本金保障",
      s2s2: "与收益发放规则",
      s2cta: "去申购",
      s3s: "涨跌预测",
      s3cta: "去预测",
    },
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI 预测 · 事件合约 · 智能分析",
    predictionCategories: {
      hot: "时间线",
      sports: "体育",
      world: "世界",
      politics: "政治",
      economy: "经济"
    },
    predictionSubCategories: {
      crypto: "现货",
      forex: "外汇",
      commodities: "贵金属"
    },
    features: {
      recharge: "充值",
      rechargeDesc: "快速充值",
      contract: "事件合约",
      contractDesc: "创新金融工具",
      predict: "AI预测",
      fund: "PANTA MARKET 金库",
      invite: "邀请好友",
      global: "全球节点"
    },
    insurance: {
      title: "合约保险资金池(JOULE)",
      poolTitle: "合约保险资金池",
      aiPoolTitle: "AI保险池",
      ordinaryPoolTitle: "事件保险池",
      approxUsdt: "≈ ${amount}",
      approxUsdtRef: "≈ ${amount}",
      approxPantaRef: "≈ {amount} PANTA",
      more: "了解更多",
      yesterday: "昨日新增",
      service: "智能客服"
    },
    market: {
      tabs: {
        main: "主流",
        hot: "热门",
        rise: "涨幅榜",
        price: "价格"
      },
      headers: {
        pair: "交易对",
        latest: "最新价",
        change: "24h涨跌"
      },
      viewMore: "查看更多",
      collapse: "收起"
    },
    announcement: {
      title: "公告",
      heading: "公告",
      text: "欢迎来到 PANTA MARKET。这里汇聚事件合约、AI 行情分析与风险保障能力，帮你更快读懂市场、更从容参与预测交易。",
      time: "2026/03/01 10:00",
      gotIt: "我知道了",
      viewDetail: "查看详情",
      systemLabel: "系统公告"
    },
    timePeriods: {
      "1min": "1分钟",
      "30min": "30分钟",
      "1hour": "1小时"
    },
    timeframes: {
      "1s": "1分钟",
      "1m": "1分钟",
      "5m": "5分钟",
      "15m": "15分钟",
      "1h": "1小时",
      "4h": "4小时",
      "1d": "1天"
    },
    footer: {
      australia: "· 澳大利亚",
      uae: "· 阿联酋",
      attention: "· 注意:",
      attentionText: "PANTA MARKET 由平台自主运营。我们不会授权任何第三方以官方名义收取费用。如有疑问，请联系官方客服：{email}"
    }
  },
  createMarket: {
    title: "创建市场",
    saveDraft: "保存草稿",
    marketTitle: "市场标题",
    titlePlaceholder: "请输入标题",
    category: "类别",
    secondaryOptional: "二级（可选）",
    deadline: "截止日期",
    optionsTitle: "预测结果（2~16 个）",
    optionsSub: "为每个选项命名",
    resetDefault: "重置默认",
    addOption: "+ 添加选项",
    ratioHint: "初始比例：全部留空则均分；填写则每个选项都要填（1~99 的整数），合计须为 100。",
    rulesSection: "规则说明 / 结算来源",
    rulesSectionSub: "可选，提示在详情页的规则与结算来源弹窗",
    rulesLabel: "规则说明",
    rulesPlaceholder: "结算判定、边界情况等",
    settleLabel: "结算来源",
    settlePlaceholder: "官方网站 / 头部新闻 / URL",
    liquidityTitle: "初始流动性",
    liquiditySub: "引导市场启动所需的资金",
    enabled: "已启用",
    disabled: "已关闭",
    investAmount: "投入金额 (JOULE)",
    balance: "余额: {n}",
    max: "最大",
    initialLiquidity: "初始流动性",
    marginRefund: "保证金（结算后退还）",
    totalTip: "保证金与流动性等额，事件结算或取消后全部退还。",
    totalDeduct: "合计扣除",
    feeTip: "提示：每次在该市场发生的交易，您都将获得 0.5% 的创建者手续费。",
    accessPassword: "访问密码",
    accessPasswordSub: "事件将带锁形标识上架，只有拿到分享链接或知道密码的人才能进入。",
    passwordPlaceholder: "设置密码（4~20 位）",
    show: "显示",
    hide: "隐藏",
    cardPreview: "卡片预览",
    deadlinePrefix: "截止 {date}",
    deadlineShort: "{m}月{d}日",
    submitting: "创建中...",
    submit: "确认并创建流动性",
    creating: "正在创建",
    createSuccess: "创建成功",
    creatingDesc: "请稍候，正在提交市场信息…",
    backHome: "返回首页",
    createAnother: "再创建一个",
    yes: "是",
    no: "否",
    optionN: "选项{n}",
    draftSaved: "草稿已保存",
    draftSaveFailed: "草稿保存失败",
    resetDone: "已重置为默认选项",
    maxOptions: "最多 16 个选项",
    minOptions: "至少保留 2 个选项",
    needMinOptions: "至少需要 2 个选项",
    fillOptionName: "请填写第 {n} 个选项名称",
    fillAllPercents: "填写比例时每个选项都要填",
    percentRange: "比例须为 1~99 的整数",
    percentSum: "比例合计须为 100（当前 {sum}）",
    enterTitle: "请输入市场标题",
    enterAmount: "请输入投入金额",
    insufficientBalance: "余额不足（含等额保证金）",
    passwordLength: "密码需 4~20 位",
    deadlineFuture: "截止日期须晚于当前时间",
    completeForm: "请完善信息",
    createdMsg: "「{title}」已创建，截止 {date} {time}",
    categories: {
      crypto: "加密货币",
      sports: "体育",
      politics: "政治",
      entertainment: "娱乐",
      tech: "科技"
    },
    subCategories: {
      general: "通用",
      spot: "现货",
      contract: "合约",
      macro: "宏观"
    }
  },
  marketDetail: {
    tabTrades: "最近成交",
    tabLp: "LP",
    tabPositions: "持仓",
    tabRules: "规则",
    colAddress: "地址",
    colTime: "时间",
    colType: "类型",
    colVolumePrice: "成交量/成交价",
    colTurnover: "成交额",
    typeBuy: "买入",
    typeSell: "卖出",
    empty: "暂无数据",
    share: "分享",
    rulesBody: "本市场为二元事件预测。结算前盘口可能锁定，锁定后等待结果公示并按持仓份额结算。请注意市场风险，理性参与。",
    priceJoule: "价格 (JOULE)",
    investJoule: "投入 (JOULE)",
    totalLiquidity: "总流动性",
    dealPrice: "成交价",
    estProfit: "预计收益",
    jouleBalance: "JOULE 余额: {n}",
    positionCount: "持仓张数: {n}",
    max: "最大",
    confirmOrder: "确认下单",
    ordering: "下单中...",
    enterAmount: "请输入投入金额",
    invalidPrice: "请输入有效价格",
    amountExceed: "投入超过可用余额",
    orderSuccess: "下单成功",
    poolSize: "池子大小",
    colBalance: "余额",
    shares: "{n}张",
    rulesTitle: "规则说明",
    rulesValue: "暂无说明",
    settleSource: "结算来源",
    settleValue: "暂无说明"
  },
  mockData: {
    tx: {
      deposit: "充值",
      withdraw: "提现",
      depositReceived: "充值到账",
      teamReward: "团队奖励",
      accelerationGrant: "加速额度发放",
      insurancePayout: "保险赔付"
    },
    finance: {
      steady7d: "稳健理财 7天",
      aggressive30d: "进取理财 30天"
    },
    notice: {
      welcomeTitle: "欢迎使用 PANTA MARKET",
      welcomeContent: "这里汇聚事件合约、AI 行情分析与风险保障能力，帮你更快读懂市场、更从容参与预测交易。",
      welcomeShort: "欢迎来到 PANTA MARKET。",
      eventContractTitle: "事件合约说明",
      eventContractContent: "连接钱包后即可体验交易流程。行情数据来自公开市场接口，请注意交易风险。",
      detailTitle: "消息详情",
      detailContent: "更多公告与产品说明，请关注消息中心与官方社群。",
      categorySystem: "系统通知",
      categoryAnnouncement: "公告"
    },
    legal: {
      terms: "PANTA MARKET 服务条款\n\n欢迎使用 PANTA MARKET（下称「本平台」）。使用本平台即表示您同意以下条款。\n\n1. 服务说明\n本平台提供 AI 预测、事件合约、资产账户等相关功能。部分行情数据来自公开市场接口，预测结果仅供参考，不构成投资建议。\n\n2. 账户与钱包\n您需自行保管钱包私钥与助记词。因私钥泄露、设备丢失或误操作导致的损失，由您自行承担。\n\n3. 风险提示\n数字资产与预测交易具有高风险，可能导致本金损失。请根据自身风险承受能力谨慎参与。\n\n4. 禁止行为\n禁止利用本平台从事洗钱、欺诈、操纵市场或其他违法违规行为。一经发现，平台有权限制或终止服务。\n\n5. 免责声明\n在法律允许范围内，本平台不对因网络中断、第三方服务异常、极端行情等导致的损失承担责任。\n\n6. 条款变更\n本平台可适时更新本条款，更新后继续使用即视为接受修订内容。\n\n如有疑问，请通过官方客服渠道联系我们。",
      privacy: "PANTA MARKET 隐私政策\n\n我们重视您的隐私。本政策说明本平台如何收集与使用相关信息。\n\n1. 我们收集的信息\n· 钱包地址、链上交互相关必要信息\n· 设备与日志信息（用于安全、排障与体验优化）\n· 您主动提交的客服/申诉材料\n\n2. 信息用途\n用于账户识别、交易与结算、风控合规、产品改进及必要的客户支持。\n\n3. 信息共享\n我们不会出售您的个人信息。仅在以下情形可能共享：法律法规要求、保护平台与用户安全、经您授权的服务协作方。\n\n4. 数据安全\n我们采取合理技术与管理措施保护数据；但互联网传输无法保证绝对安全，请您同时做好本地安全防护。\n\n5. 您的选择\n您可停止使用服务、断开钱包连接。涉及链上公开数据的部分无法由平台单方面删除。\n\n6. 政策更新\n本政策可能更新，重大变更将通过产品内提示等方式告知。\n\n如有隐私相关问题，请联系官方客服。"
    }
  },
  sports: {
    upcoming: "未开赛",
    gameView: "游戏视角",
    empty: "暂无比赛",
    draw: "平局",
    viewMore: "查看更多"
  },
  wealthAccess: {
    exchangeThresholdFailed: "兑换失败，未满足门槛",
    internalPrice: "内部价",
    marketPrice: "市场价",
    coinBasis: "币本位",
    legacyBasis: "币本位",
    contractBasis: "结算类型",
    unitPrice: "成交单价",
    quotaUsed: "内部价累计申购",
    quotaRemaining: "内部价剩余额度",
    quotaHint: "跨套餐累计限 {limit} PANTA，关闭内部价、到期或等级变化不清零。",
    principal: "本金",
    principalReturn: "到期返还本金",
    dailyYield: "每日毛收益",
    coinYieldHint: "每日毛收益 = PANTA 本金 × 年化比例 ÷ 360，向下取整；币价变化不影响合同枚数，实际分配按规则执行。",
    legacyHint: "此为币本位合同；到期 PANTA 还本按合同规定的到期价格折算。",
    quotaError: "超过内部价剩余额度，请减少数量；不会自动拆单或改为市场价。",
    permissionChanged: "当前 VIP 已无权申购该套餐，套餐列表已更新。",
    quoteChanged: "报价或资格已变化，请核对新报价后再次确认。",
    quoteExpired: "报价已过期，请刷新报价后确认。",
    retryQuote: "刷新报价",
    stakeGateTitle: "PANTA 卖出需满足质押门槛",
    stakeGateBody: "当前 VIP{vip}：有效质押 {staked} PANTA，需 {required} PANTA，还差 {shortfall} PANTA。仅限制卖出，不影响买入。",
    goStake: "前往质押",
    refreshEligibility: "刷新资格",
  },
  fundPage: {
    heroTitle: "每日发放PANTA收益",
    heroDesc: "申购Galaxy基金，获取年化分红",
    learnMore: "了解更多",
    allProducts: "全部产品",
    subscribe: "申购",
    stake: "质押",
    stakePreview: "质押预览",
    searchCoin: "搜索币种",
    allPeriods: "全部周期",
    colCoin: "基金名称",
    colApy: "币本位年化",
    colTerm: "期限",
    fixedTerm: "定期",
    galaxyProduct: "Galaxy {n}号",
    termLabel: "期限",
    apyLabel: "年化",
    stakeCap: "个人持仓",
    stakeAmount: "质押金额",
    tradingJouleBalance: "交易账户余额",
    estEarnings: "预计收益",
    stakeDisclaimer: "收益为参数示意，不构成保证。到账分配约 70% 至可用余额、30% 至体验金；体验金需完成约 3 倍流水后方可解冻。",
    stakeSuccess: "质押成功",
    annualized: "参考年化",
    perShareYield: "万份收益(WBS)",
    dayUnit: "天",
    empty: "暂无基金产品",
    loadFailed: "加载失败",
    rulesTitle: "基金说明",
    gotIt: "我知道了",
    pantaAvailable: "PANTA 可用",
    activeFaceValue: "在投份额",
    totalReward: "基金累计收益(PANTA)",
    fundYieldUnavailable: "--/请更新服务",
    effectiveVip: "有效等级",
    myHoldings: "基金购买记录",
    faceValue: "价值",
    maturity: "到期",
    stakeStart: "质押时间",
    pantaPrice: "PANTA 单价",
    noMoreHoldings: "没有更多持仓了",
    subscriptionStatus: {
      ACTIVE: "进行中",
      SETTLED: "已结算",
      CANCELLED: "已取消",
      MANUAL_REVIEW: "人工审核",
    },
    minPanta: "起购 PANTA",
    pantaAmount: "申购数量（PANTA）",
    stepHint: "须为 {step} 的整数倍，最少 {min}",
    getQuote: "获取报价",
    confirmStake: "确认质押",
    jouleDebit: "扣除 JOULE",
    expectedPanta: "质押 PANTA",
    quoteExpires: "报价有效至",
    unavailable: "暂未开放",
    invalidAmount: "请输入符合步长的 PANTA 数量",
    quoteFailed: "报价失败",
    rewards: "基金奖励",
    unlock: "PANTA 冻结批次",
    unlockProgress: "已用交易流水",
    pantaLedger: "PANTA 账本"
  },
  rank: {
    applyTitle: "申请成为达人",
    applyDesc: "展示您的交易才华，赢取收益分成",
    applyCta: "立即入驻",
    tabExpert: "达人排行榜",
    tabMaker: "做市商排行榜",
    tabWinRate: "胜率榜",
    tabProfit: "盈利榜",
    comingSoon: "敬请期待",
    tagPolitics: "政治",
    tagEsports: "电竞",
    experts: {
      trendCatcher: "趋势捕捉者",
      whaleWatcher: "巨鲸观察家",
      cryptoWolf: "币圈老狼",
      swingCaptain: "波段队长",
      arbHunter: "套利猎手",
      bullKnight: "牛市骑士"
    }
  },
  withdrawSheet: {
    title: "提现",
    balance: "余额",
    processing: "JOULE 提现中...",
    success: "JOULE 提现成功！",
    withdrawing: "提现中...",
    withdrawSuccess: "提现已受理，请在记录中查看进度",
    recordBadge: "提现记录",
    sheetTitle: "提现 {token}",
    sheetDesc: "最低 {min} USDT，手续费以提交结果为准",
    available: "可用 {token}",
    amountLabel: "提现金额",
    amountPlaceholder: "输入金额（最低 {min} USDT）",
    vault: "Vault 合约",
    feeHint: "预估手续费仅供参考；最终以服务端创建响应的 fee/net 为准",
  },
  depositSheet: {
    broadcastPending: "交易已广播，正在同步充值状态，请勿重复转账",
    broadcastSavedWarning: "交易已广播，但本地记录保存失败，请保留哈希联系管理员：",
    creditSummary: "充值 {input} USDT → 已兑换为 {output} {asset}",
    autoExchange: "充值的 USDT 将按到账时汇率自动兑换为 Joule，免兑换手续费。",
    title: "存入 JOULE",
    depositTo: "充值至",
    spotAccount: "现货账户",
    network: "网络",
    networkWarning: "仅支持BSC/BEP20网络充值，若使用其他网络导致资产损失，无法找回",
    depositAddress: "收款地址",
    address: "地址",
    depositTAKER: "充值JOULE",
    generating: "生成中...",
    generateSuccess: "生成成功",
    generateFailed: "生成失败",
    saveAndShare: "保存并分享地址",
    more: "更多",
    save: "保存",
    wechat: "微信",
    recordBadge: "充值记录",
    sheetDesc: "从当前登录钱包向收款地址转入配置的 USDT",
    wallet: "钱包",
    max: "最大",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "保存的图片",
    download: "下载",
    pleaseGenerate: "请先生成图片",
    downloadSuccess: "下载成功",
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    pleaseUseDapp: "请使用钱包打开 DApp 操作",
    needPermission: "需要保存图片到相册的权限",
    recharge: "充值",
    rechargeAddress: "充值地址",
    copy: "复制",
    copySuccess: "复制成功",
    loadingAddress: "正在获取充值地址...",
    loadAddressFailed: "获取充值地址失败",
    clickToRetry: "点击重试",
    loading: "加载中...",
    loadFailed: "获取充值地址失败",
    claimButton: "认领充值",
    claimDesc: "向充值地址转账 USDT 后，粘贴交易哈希认领（受理≠到账）",
    txHash: "交易哈希",
    txHashPlaceholder: "粘贴 0x 开头的 64 位交易哈希",
    environment: "环境",
    envMainnet: "主网",
    envTestnet: "测试网",
    confirmations: "所需确认数",
    tokenContract: "USDT 合约",
    stepsTitle: "充值步骤",
    step1: "确认网络与收款地址，仅向该地址转账配置的 USDT",
    step2: "在钱包完成链上转账",
    step3: "粘贴交易哈希并认领，在充值记录中查看处理进度",
    optionalAmount: "金额（可选，仅备注）"
  },
  fundRecords: {
    depositTitle: "充值记录",
    withdrawTitle: "提现记录",
    exchangeTitle: "兑换记录",
    feeLabel: "手续费: {fee}",
    detailTitle: "记录详情",
    statusLabel: "状态",
    amountLabel: "金额",
    ledgerTitle: "关联流水",
    ledgerEmpty: "暂无关联流水",
    claimHint: "申报记录，金额以关联转账为准",
    confirmProgress: "确认数 {cur}/{req}",
    depositStatus: {
      PENDING_CHAIN: "等待链上交易",
      PENDING: "处理中",
      UNMATCHED: "未匹配到转账",
      CONFIRMING: "已识别，等待确认",
      CONFIRMED: "链上核验完成，等待入账",
      CREDITED: "已到账",
      REJECTED: "核验失败",
      MANUAL_REVIEW: "异常复核中",
      REORGED: "链重组待复核",
      VERIFIED: "已核验",
    },
    withdrawStatus: {
      PENDING_REVIEW: "等待审核",
      AUTHORIZED: "已审核，等待链上执行",
      BROADCASTING: "链上交易已发送，等待确认",
      CONFIRMED: "提现完成",
      REJECTED: "审核拒绝，资金已解冻",
      EXPIRED: "授权过期",
      MANUAL_REVIEW: "链上凭据异常，人工复核中",
    },
  },
  withdraw: {
    title: "提币",
    headerTitle: "提币",
    address: "提币地址",
    addressLabel: "提币地址",
    addressPlaceholder: "请输入或粘贴地址",
    addressHint: "提币将发送到您的钱包地址",
    network: "网络",
    selectNetwork: "选择网络",
    networkHint: "请确保提币地址与所选网络匹配",
    withdrawAmount: "提现数量",
    receiveAmount: "实际到账",
    networkFee: "网络手续费",
    submit: "确认提币",
    submitButton: "提现",
    balance: "余额",
    all: "全部",
    amountPlaceholder: "请输入",
    minimumWithdrawal: "最低提现数量：{amount} USDT",
    minimumWithdrawalTAKER: "最低提现数量：{amount}JOULE",
    fee: "手续费",
    confirm: "确定",
    confirmTitle: "确认操作",
    confirmContent: "是否确认执行该操作？",
    toasts: {
      fetchFailed: "获取资产失败",
      enterAddress: "请输入提币地址",
      enterValidAmount: "请输入有效提币数量",
      insufficientBalance: "余额不足",
      minimumAmount: "最低提现数量为 {amount} USDT",
      processing: "处理中...",
      success: "提币成功！",
      requestSuccess: "提现申请成功",
      requestFailed: "提现失败，请重试",
      notConfigured: "提现暂未开放，请稍后再试"
    }
  },
  appeal: {
    title: "资产辅助审核",
    records: "提交记录",
    recordsTitle: "提交记录",
    noRecords: "暂无提交记录",
    submitTime: "提交时间",
    statusPending: "待处理",
    statusApproved: "通过",
    statusRejected: "驳回",
    failedReason: "拒绝原因",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "加载中...",
    walletAddress: "绑定 PANTA MARKET 的地址",
    address: "地址",
    walletAddressPlaceholder: "请输入 PANTA MARKET 登录地址",
    autoFill: "自动填充",
    depositAmount: "充值金额",
    depositAmountPlaceholder: "请输入充值金额",
    tokenType: "币种",
    selectToken: "请选择币种",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "转账时间",
    selectTime: "请选择转账时间",
    timeRangeHint: "2026年3月5日 00:00 至 3月11日 10:00（SGT）期间产生的相关数据。",
    txHash: "HASH / TXID",
    txHashPlaceholder: "请输入交易哈希值",
    txHashHint: "可在区块链浏览器中查询",
    uploadImages: "转账记录截图",
    uploadHint: "选填，最多上传9张图片",
    addImage: "添加图片",
    submit: "提交",
    submitting: "提交中...",
    submitSuccess: "提交成功",
    submitFailed: "提交失败，请重试",
    uploadingImages: "上传图片中...",
    uploadImagesFailed: "图片上传失败",
    warningTitle: "重要提示",
    warningText: "提交记录通过验证成功，同时奖励申购算力的5%。如若虚假提供，冻结账号。"
  },
  deposit: {
    headerTitle: "USDT充值",
    qrTitle: "USDT充值",
    addressLabel: "充值至",
    addressCopied: "地址已复制",
    connectPrompt: "请先连接钱包",
    usdtBalance: "USDT余额",
    amaBalance: "JOULE余额",
    amount: "金额",
    amountPlaceholder: "输入 {token} 金额",
    minimumNotice: "最小 {min} {token}",
    confirm: "提交",
    processing: "处理中...",
    helpText: "充值说明：请确保您的钱包有足够的余额",
    depositNotice:
      "请向收款地址转入配置的 USDT 后认领；202 仅受理，CREDITED 才是已到账",
    toasts: {
      invalidAmount: "充值数量不能少于 {min} {token}",
      insufficientFunds: "余额不足",
      checkingAllowance: "检查授权额度...",
      approving: "授权中...",
      approveSuccess: "授权成功",
      depositing: "充值中...",
      depositSuccess: "充值成功",
      depositFailed: "充值失败",
      balanceLoadFailed: "无法读取钱包测试币余额，请刷新后重试",
      userCancelled: "您已取消操作",
      wrongNetwork: "请切换到正确的网络",
      contractError: "合约执行失败",
      gettingPaymentInfo: "获取支付信息...",
      cannotGetBalance: "无法获取余额，请刷新后重试",
      enterValidAmount: "请输入有效的金额",
      claimPending: "充值已受理，请在记录中查看到账进度",
      invalidTxHash: "请输入有效的交易哈希（0x + 64 位十六进制）",
      configNotReady: "充值暂未开放，请稍后再试"
    }
  },
  team: {
    headerTitle: "我的团队",
    contractEarnings: "交易收益",
    btcFund: "理财收益",
    stats: {
      personalEarnings: "个人累计收益",
      teamEarnings: "团队收益",
      personalVolume: "个人流水",
      teamVolume: "团队流水",
      personalPower: "个人算力",
      teamTotalPower: "团队总算力",
      periodPersonal: "个人流水",
      periodTeam: "团队收益",
      totalTeam: "团队流水",
      personalSubscribed: "个人质押量",
      teamSubscribed: "团队质押量"
    },
    unclassifiedHint: "历史赔付来源待核对：{amount} {asset}",
    links: {
      invite: "邀请好友",
      details: "团队明细"
    },
    inviteBannerTitle: "邀请好友解锁团队佣金",
    inviteBannerSubtitle: "解锁你的团队佣金",
    inviteBannerCta: "立即参与"
  },
  teamDetails: {
    myReferrals: "我的邀请",
    currentLevel: "当前等级：{level}",
    effectiveLevel: "当前有效等级：{level}",
    nextLevel: "下一等级",
    nextLevelClosed: "暂未开放",
    totalMembers: "直推人数",
    activatedCount: "激活人数",
    validMembers: "有效人数",
    teamLevel: "团队等级: {level}",
    tradeTeam: "交易团队",
    financeTeam: "基金团队",
    predictTeam: "预测团队",
    teamMembers: "团队成员",
    teamData: "团队数据",
    teamEarningsJoule: "团队收益",
    teamFlowJoule: "团队总流水",
    teamPowerUsdt: "团队总流水",
    teamTotalCount: "团队人数",
    teamEarningsWithUnit: "团队收益（{unit}）",
    teamVolumeWithUnit: "团队总流水（{unit}）",
    teamActiveStakeWithUnit: "团队当前质押数量（{unit}）",
    effectiveTradingCount: "交易有效人数",
    activeInvestorCount: "基金在投人数",
    dividendEligibleCount: "分红资格已激活人数",
    myTeamReward: "团队收益",
    teamPerformance: "团队总流水",
    directMembers: "团队成员",
    filterAll: "全部",
    filterEffective: "业务有效",
    filterDividend: "分红达标",
    filterDirect: "直推",
    filterIndirect: "间推",
    addRemark: "添加备注",
    editRemark: "修改备注",
    saveRemark: "修改",
    remarkPlaceholder: "请输入备注",
    remarkSaved: "备注已保存",
    remarkFailed: "备注保存失败",
    myCurrentLevel: "当前等级：{level}",
    personalTradePerf: "个人交易流水总业绩：{value}",
    personalStakePerf: "个人质押流水总业绩：{value}",
    currentTotalPerf: "本人升级业绩：{value}",
    currentAreaPerf: "团队升级业绩：{value}",
    viewingIndirect: "{name}的直推",
    includesAllLevels: "含全部层级",
    inviteDetails: "邀请明细",
    startDate: "开始日期",
    endDate: "结束日期",
    dateTo: "至",
    status: "状态：",
    statusActivated: "已激活",
    statusNotActivated: "未激活",
    statusDividendActivated: "分红资格已激活",
    statusDividendNotActivated: "分红资格未激活",
    statusValid: "已激活",
    statusInvalid: "未激活",
    time: "绑定时间",
    bindTime: "绑定时间",
    level: "等级",
    tradeLevel: "交易等级",
    fundLevel: "基金等级",
    inviteType: "邀请类型",
    viewTeam: "团队详情",
    viewDetail: "查看详细",
    noSubMembers: "该成员暂无直推",
    directCount: "直推人数",
    teamSize: "团队人数",
    teamTotalPerf: "团队总业绩",
    teamTotalStake: "团队当前质押数量",
    personalTotalPerf: "个人总业绩",
    personalTotalStake: "个人当前质押数量",
    settledOrderCount: "累计已结算订单数",
    activeSubscriptionCount: "有效在投套餐数",
    eventContractParticipants: "累计已结算订单数",
    communityValidCount: "分红达标：",
    communityTotalPerf: "本人业绩：",
    areaTotalPerf: "有效质押：",
    yesterdayStake: "昨日新增质押数量：",
    communityMaxLevel: "社区最高等级：",
    personalEquity: "个人权益金：",
    peopleUnit: "{n}人",
    loadFailed: "加载失败，请重试",
    forbidden: "无权查看该团队"
  },
  teamMemberModal: {
    totalProfit: "总收益",
    totalFlow: "总流水",
    totalInvites: "总邀请人数",
    validMembers: "总有效人数"
  },
  my: {
    headerTitle: "我的",
    login: "点击登录",
    inviteCode: "邀请码:",
    groups: {
      common: "常用功能",
      trading: "交易",
      finance: "理财",
      help: "帮助"
    },
    features: {
      invite: "邀请好友",
      team: "我的团队",
      insurance: "事件合约保险",
      contract: "事件合约",
      exchange: "闪兑",
      fund: "AI金库基金",
      communitySquare: "社区广场",
      createEvent: "创建事件",
      community: "官方社群",
      terms: "服务条款",
      announcement: "公告",
      privacy: "隐私政策",
      aboutUs: "关于我们"
    }
  },
  sidebar: {
    loginAccount: "登录账号",
    inviteBanner: "邀请好友拿团队佣金",
    inviteCode: "邀请码",
    defaultName: "PANTA MARKET",
    logoutWallet: "退出钱包登录"
  },
  community: {
    title: "官方社群",
    bannerTitle1: "加入我们的社群",
    bannerTitle2: "与全球用户交流",
    linkCopied: "链接已复制"
  },
  supportPage: {
    title: "联系客服",
    hello: "PANTA MARKET 客服中心",
    desc: "当前为演示入口，正式工单系统上线前可通过下方邮箱或社群联系我们。",
    emailLabel: "客服邮箱",
    hoursLabel: "服务时间",
    hoursValue: "每日 10:00–22:00（SGT）",
    channelLabel: "推荐渠道",
    channelValue: "官方社群 / 邮箱工单",
    copy: "复制",
    tip: "请勿向任何自称「官方」的第三方转账或授权。平台不会主动索要私钥与助记词。",
    goCommunity: "前往官方社群"
  },
  invite: {
    headerTitle: "邀请好友",
    rulesEntry: "邀请规则",
    subtitle: "团队每笔交易你都能赚",
    mainTitle: "邀请赚佣",
    description: "分享链接，朋友交易你拿奖励",
    bindSuperior: "绑定上级",
    bindPlaceholder: "输入邀请码或钱包地址",
    bindButton: "绑定",
    binding: "绑定中…",
    boundLabel: "已绑定上级",
    modalDesc: "尚未绑定上级。可填写邀请码或钱包地址，绑定后可参与团队奖励。邀请链接中的信息会自动填入；无邀请信息时已预填默认上级。",
    later: "稍后",
    yourCode: "你的邀请码",
    shareLink: "分享链接",
    inviteButton: "邀请好友",
    mainTitle_old: "邀请好友一起赚",
    subTitle: "获得高额返佣",
    viewRules: "查看推荐规则",
    rulesLink: "查看返佣规则 >",
    rulesTitle: "返佣规则",
    rules: {
      commissionTable: {
        title: "PANTA MARKET 交易流水佣金表",
        headers: {
          level: "级别",
          personalTurnover: "自身流水",
          teamTurnover: "团队流水",
          commission: "团队佣金"
        }
      }
    },
    inviteBoxTitle: "邀请好友",
    referralCode: "邀请码",
    inviteLink: "邀请链接",
    loading: "加载中...",
    copyButton: "复制邀请链接",
    toasts: {
      emptyContent: "内容为空",
      copySuccess: "复制成功",
      bindSuccess: "绑定成功",
      bindFailed: "绑定失败",
      alreadyBound: "已绑定上级，不可更换",
      loginFirst: "请先连接钱包",
      invalidCode: "请输入有效邀请码或钱包地址",
      cannotBindSelf: "不能绑定自己",
    }
  },
  finance: {
    title: "理财页面开发中..."
  },
  finanfund: {
    title: "PANTA MARKET 金库基金",
    subtitle: "简单 高效 轻松赚币",
    productName: "PANTA MARKET 金库基金",
    minAmount: "单笔最少",
    incomeRatio: "收益比例",
    lockPeriod: "锁仓周期",
    dailyReturn: "日收益",
    earning: "获得",
    redemptionRules: "赎回规则",
    rules: {
      rule1: "PANTA MARKET 金库基金托管后不可赎回",
      rule2: "每日收益自动到账",
      rule3: "锁仓金额将以锁仓结束后返回账户"
    },
    subscription: "认购",
    amountPlaceholder: "请输入",
    balance: "余额",
    availableFunds: "可用资金",
    all: "全部",
    subscribeButton: "认购",
    internalAssetSubscribeButton: "内部资产入金",
    toasts: {
      productIdNotExist: "产品ID不存在",
      enterValidAmount: "请输入有效的认购金额",
      minAmountRequired: "认购金额不能低于{amount}USDT",
      subscribeSuccess: "认购成功",
      subscribeFailed: "认购失败",
      internalAssetSubscribeSuccess: "内部资产入金成功",
      internalAssetSubscribeFailed: "内部资产入金失败"
    }
  },
  assets: {
    totalAssetsUsdt: "预估总价值（USDT）",
    availableAssets: "可用资产",
    noHoldings: "暂无持仓",
    mainSystemPanta: "主系统（PANTA）",
    transferToMain: "划转到主系统",
    tradeFrozenJoule: "交易冻结(JOULE)",
    insuranceAccountJoule: "保险账户(JOULE)",
    payoutPower: "算力节点赔付",
    payoutEquity: "AI预测赔付(JOULE)",
    mainAccount: "交易账户",
    insuranceAccountShort: "保险账户",
    copyAccountShort: "跟单账户",
    copyAccountJoule: "跟单账户(JOULE)",
    tradingAccountHelpTitle: "交易账户余额",
    copyAvailableLabel: "可用余额",
    copyFrozenLabel: "冻结余额",
    copyTotalPnl: "跟单总盈亏",
    transferSheet: {
      title: "划转",
      pairCopy: "交易账户/跟单账户",
      pairInsurance: "交易账户/保险账户",
      tradingAccount: "交易账户",
      copyAccount: "跟单账户",
      insuranceAccount: "保险账户",
      jouleHint: "仅支持 JOULE 划转",
      submit: "提交",
      transferring: "划转中...",
      success: "划转成功",
      failed: "划转失败，请重试",
    },
    computeNode: "算力节点",
    stakedTotalPanta: "基金个人质押总额",
    stakedPlusRewardPanta: "质押本金+预计收益",
    stakedPlusRewardTipTitle: "质押本金 + 预计收益",
    stakedPlusRewardTip: "该数值为质押本金与预计总收益之和。",
    stakedPrincipalLabel: "质押本金",
    stakedExpectedYieldLabel: "预计收益",
    annualEarningsPanta: "基金个人收益已发放",
    frozenTotalPanta: "冻结总额",
    unlockedTotalPanta: "累计已解冻",
    fundTeamPendingPanta: "基金团队收益待发放（PANTA）",
    fundTeamPaidPanta: "基金团队收益已发放（PANTA）",
    pendingRewardPanta: "今日待空投",
    paidRewardPanta: "已空投",
    expectedAirdropQuota: "预计待空投额度",
    cumulativeAirdropValue: "累计空投价值：{value} USDT",
    roundExpectedValue: "本轮预计价值：{value} USDT",
    historyTotalValue: "历史总价值：{value} USDT",
    nextAirdropAt: "下次发放时间：{time}",
    airdropEstimateUnavailable: "暂无法估算",
    roundExpectedValueUnavailable: "本轮预计价值：暂无法估算",
    airdropEstimateHint: "预估值，以实际结算为准",
    roundProgress: "节点生成进度",
    currentNodeCount: "当前节点数",
    deductedNodeCount: "扣除节点数",
    invalidNodeCount: "失效节点数",
    todayRelease: "今日释放",
    releaseFrozenPanta: "释放冻结",
    unlockQuota: "解锁额度",
    unlockQuotaNote: "今日可解锁额度 0.0000",
    tradeNode: "交易节点",
    tradeNodeDesc: "购买后直接升级 VIP3，解锁专属交易权益",
    tradeNodeHint: "购买节点仅获名额，价格以报价为准",
    buyNode: "购买节点",
    buyNodeModal: {
      title: "购买交易节点",
      description: "支付{amount}JOULE即可获得交易节点资格",
      quotePreview: "{name} · {amount} JOULE · 剩余{remaining}",
      afterBalance: "买后余额约 {amount} JOULE",
      pickProduct: "选择节点商品",
      availableBalance: "当前可用余额",
      cancel: "取消购买",
      confirm: "确认购买",
      purchasing: "购买中...",
      success: "购买成功",
      failed: "购买失败，请重试",
      insufficient: "余额不足，请先充值",
      unavailable: "暂未开放"
    },
    tradingAccountRecords: "交易明细",
    wealthAccountRecords: "基金明细",
    insuranceAccountRecordsShort: "保险账户记录",
    detailTitle: "资产明细",
    jouleConvert: "JOULE 折算（×汇率）",
    usdtPart: "USDT 部分",
    jouleAvailable: "JOULE 可用",
    tradeFrozen: "交易冻结(JOULE)",
    financeReleaseFrozen: "理财释放冻结(JOULE)",
    insuranceFrozen: "保险冻结额度(JOULE)",
    usdtAvailableLabel: "USDT 可用",
    usdtFrozenLabel: "USDT 冻结",
    totalSum: "合计",
    available: "可用",
    deposit: "充币",
    withdraw: "提现",
    myAccountRecords: "我的账户记录",
    nodeEquityHint: "USDT 计价节点权益，非现金到账",
    nodeEquityRate: "实际发放比例 {rate}%",
    nodeEquitySources: {
      PERSONAL: "普通保险个人权益",
      TEAM: "普通保险团队权益",
      ADMIN: "平台空投",
      AI_INSURANCE: "AI 保险节点权益赔付",
      BACKFILL: "AI 保险节点权益补发",
      OTHER: "节点权益增加",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "节点权益增加",
      BET_STAKE: "下注冻结",
      WIN_PAYOUT: "交易盈利",
      LOSS_SETTLEMENT: "交易亏损",
      REFUND: "退款",
      INSURANCE_PREMIUM: "保费支出",
      INSURANCE_PAYOUT: "保险赔付",
      INSURANCE_TRANSFER_IN: "保险转入",
      INSURANCE_TRANSFER_OUT: "保险转出",
      NETWORK_DIFFERENTIAL: "交易级差奖",
      NETWORK_PEER: "交易平级奖",
      NETWORK_UNLOCK: "收益解冻",
      EVENT_INSURANCE_PAYOUT: "算力节点赔付",
      EVENT_INSURANCE_PEER: "算力平级奖",
      TRANSFER_IN: "转入",
      TRANSFER_OUT: "转出",
      PREMIUM_LOCK: "保费锁定",
      PREMIUM_SETTLE: "保费支出",
      PREMIUM_REFUND: "保费退回",
      WEALTH_SUBSCRIPTION: "基金申购",
      SUBSCRIPTION_LOCK: "质押锁定",
      WEALTH_DAILY_REWARD: "基金日息",
      WEALTH_TEAM_REWARD: "基金团队奖",
      MATURITY_RELEASE: "到期返本",
      WEALTH_UNLOCK: "收益解冻",
      COPY_SHARE_HOLD: "跟单分润冻结",
      COPY_SHARE_RELEASE: "跟单分润解冻退回",
      COPY_SHARE_PAYOUT: "跟单分润支出",
      COPY_TRADE_TRANSFER_OUT: "划出至跟单账户",
      COPY_TRADE_TRANSFER_IN: "从跟单账户划入",
      /** account=COPY_TRADE 时覆盖同 type 文案 */
      COPY_WIN_PAYOUT: "跟单盈利",
      COPY_LOSS_SETTLEMENT: "跟单亏损",
      COPY_TRANSFER_IN: "转入跟单账户",
      COPY_TRANSFER_OUT: "转出跟单账户",
      COPY_SHARE_PAYOUT_IN: "跟单分润入账",
      COPY_SHARE_POOL_IN: "跟单分润入池",
      COPY_SHARE_POOL_REFUND: "跟单分润退回",
      COPY_SHARE_POOL_MIGRATION: "跟单分润迁移",
      COPY_FLOW: "跟单流水",
    },
    recordCategories: {
      NODE_EQUITY: "节点权益",
      TRADE_PNL: "交易盈亏",
      PREMIUM: "保费支出",
      INSURANCE_PAYOUT: "保险赔付",
      TEAM_REWARD: "团队奖励",
      COPY: "跟单明细",
      COPY_TRADE_PNL: "跟单盈亏",
      COPY_SHARE: "跟单分润",
      COPY_TRANSFER: "跟单划转",
      WEALTH_REWARD: "基金日息",
      UNLOCK: "收益解冻",
      PRINCIPAL: "质押/返本",
      TRANSFER: "内部划转"
    },
    amountPendingReview: "金额待核对",
    creditedSplit: "可用到账{available} · 冻结到账{frozen}",
    creditedSplitPending: "拆分待核对",
    afterBalance: "变动后可用{available} · 冻结{frozen}",
    unlockHint: "冻结转可用，不计新增收益",
    transferFromInsurance: "保险账户",
    transferFromMain: "主账户",
    all: "全部",
    transfer: "划转",
    insuranceDeduction: "保险扣费",
    insurancePayout: "保险赔付",
    noRecords: "暂无记录",
    frozenOp: "冻结 {amount} {token}",
    lockedOp: "锁定 {amount} {token}",
    availableChange: "可用 {amount}",
    frozenChange: "冻结 {amount}",
    detail: {
      sessionId: "会话 ID",
      networkReward: "团队奖励详情",
      insuranceClaim: "AI赔付详情",
      creditStatus: "到账状态",
      creditedPendingHint: "已到账，处理确认重试中",
      orderId: "来源订单",
      source: "来源",
    },

    actions: {
      deposit: "充值",
      withdraw: "提现",
      exchange: "兑换",
      transfer: "划转"
    },
    loginPrompt: {
      text: "请先连接钱包",
      button: "连接"
    },
    toasts: {
      connectFailed: "连接失败，请重试"
    },
    jouleUsdtRate: "1 JOULE = {rate} USDT",
    pantaUsdtRate: "1 PANTA = {price} USDT",
  },

  wallet: {
    title: "我的钱包",
    address: "钱包地址",
    addressCopied: "地址已复制",
    inviteCode: "邀请码",
    logout: "退出登录",
    login: "登录",
    toasts: {
      networkSwitchCancelled: "用户取消了网络切换",
      networkConfigNotFound: "未找到网络配置 {chainId}",
      signatureCancelled: "用户取消了签名",
      connectionFailed: "连接钱包失败",
      accountSwitched: "钱包账户已切换，请重新连接",
      connectionTimedOut: "连接超时，请重试",
      loginSuccess: "登录成功",
      logoutSuccess: "已退出登录",
      switchNetwork: "请先在钱包中切换到 {chainName} 后再重试充值",
      wrongChain: "当前网络不支持，请切换到 {chainName}",
      switchingNetwork: "正在切换网络...",
      switchNetworkFailed: "网络切换失败，请在钱包中手动切换到 {chainName}"
    }
  },
  market: {
    title: "行情",
    banner: {
      title: "事件合约",
      desc: "释放链上赚币的收益潜力"
    },
    tabs: {
      main: "主流币",
      rise: "涨幅榜"
    },
    types: {
      crypto: "加密货币",
      stocks: "美股",
      forex: "外汇",
      commodities: "贵金属",
      favorites: "自选"
    },
    headers: {
      pair: "交易对",
      price: "最新价",
      change: "今日涨跌幅"
    },
    loading: "加载中...",
    loadingMore: "加载更多...",
    noMoreData: "没有更多数据了"
  },
  notice: {
    loginRequired: "请先登录后查看公告",
    empty: "暂无公告",
    unpublished: "已下线",
    current: "当前",
    title: "消息中心",
    helpCenter: "帮助中心",
    noticeDetail: "公告详情",
    defaultCategory: "通知",
    viewDetail: "查看详情",
    pdfViewer: "PDF预览",
    videoPlayer: "视频播放",
    imageViewer: "图片预览",
    documentViewer: "文档预览",
    clickToViewPdf: "点击查看PDF",
    clickToViewDocument: "点击查看文档",
    openInBrowser: "在浏览器中打开",
    tryingViewer: "正在尝试方案 {current}/{total}",
    pdfLoadFailed: "PDF预览加载失败，请下载查看",
    downloadPdf: "下载PDF文件"
  },
  trade: {
    title: "事件合约",
    nextRound: "下一轮",
    posCurrent: "当前",
    aiThenPrefix: "当时 AI：",
    aiUnlinked: "未关联 AI",
    aiNotRecorded: "未记录",
    insuranceLabel: "保险",
    amountLabel: "金额",
    insuranceNotSelected: '未选择',
    insuranceInactive: "未生效",
    insuranceTypeNone: "未生效",
    insuranceTypeEvent: "普通保险已投保",
    insuranceTypeEventShort: "普通保险",
    insuranceTypeAi: "AI保险已生效",
    insuranceTypeAiShort: "AI保险",
    insuranceTypeConverted: "已转普通保险",
    insuranceTypeUnknown: "保险状态待确认",
    inProgress: "进行中",
    estimatedPnl: "预估盈亏",
    settlementConfirming: "结算中，正在确认结果",
    balanceSyncing: "余额同步中",
    pendingReview: "待核对",
    openPriceLabel: "开盘价",
    secondsUnit: "秒",
    connecting: "连接中...",
    connectWallet: "连接",
    platformLadder: {
      title: "平台参考报价",
      current: "现价",
      ask: "卖{n}",
      bid: "买{n}",
      disclaimer: "价格经平台加工，数量参考交易所，非可成交挂单",
      unavailable: "参考报价暂不可用",
    },
    actions: {
      rise: "买涨",
      fall: "买跌",
      buy: "买入",
      sell: "卖出"
    },
    orderSuccess: "下单成功！",
    orderFailed: "下单失败",
    orderConfirming: "正在确认下单结果，请勿重复操作",
    orderNotFilled: "本次下单未成交，未扣款",
    unsettledIntervalConflict: "同币种同周期已有未结订单，请等待结算或更换周期",
    invalidInterval: "周期参数无效，请重新选择",
    chartPlatform1mOnly: "该品种图表仅支持平台 1 分钟行情",
    orderDetail: {
      title: "订单详情",
      orderId: "订单号",
      symbol: "交易对",
      interval: "周期",
      direction: "实际方向",
      aiDirection: "当时 AI",
      openTime: "开仓时间",
      settleTime: "到期时间",
      settledAt: "结算时间",
      openPrice: "开仓价",
      closePrice: "结算价",
      stake: "本金",
      premium: "保费",
      netProfit: "净盈亏",
      status: "状态",
      orderSource: "订单来源",
      converted: "保险转换",
      notRecorded: "未记录",
      copied: "订单号已复制",
    },
    orderStatus: {
      CREATED: "已创建",
      ACCEPTED: "已受理",
      CLOSED: "已关闭",
      FUNDS_LOCKED: "资金已锁定",
      AWAITING_SETTLEMENT: "待结算",
      PROCESSING: "处理中",
    },
    insuranceBalanceInsufficient: "保险账户余额不足",
    mainBalanceInsufficient: "主账户余额不足",
    insuranceBalanceRequired: "保险账户余额不足，无法开启保险",
    insuranceRulesUnavailable: "保费规则未就绪，无法开启保险",
    insuranceMainRequired: "主账户余额不足，无法开启保险",
    preferenceLoading: "保险设置加载中",
    preferenceLoadFailed: "保险设置加载失败，请重试",
    preferenceSaveFailed: "保险设置保存失败，请重试",
    preferenceSessionEndedSaveFailed: "轮次已结束，关闭设置未保存",
    premiumEstimate: "预计保费 {premium} JOULE（{rate}%）",
    premiumShortfallHint: "保险账户还差 {amount} JOULE，无法开启",
    premiumEstimateUnavailable: "暂无法估算保费",
    premiumBoundEstimate: "已绑定策略预计保费 {premium} JOULE",
    insuranceConfirmTitle: "确认保费",
    insuranceConfirmBody: "预览保费 {premium} JOULE。以预览结果为准，确认后提交。",
    recoverTitle: "恢复未确认订单",
    recoverContent: "检测到未确认事件合约订单（{symbol} {direction} {amount}）。将使用原幂等键确认，不会重复下单。",
    recoverConfirm: "确认订单",
    recoverCancel: "取消",
    holdings: {
      current: "当前持仓",
      history: "历史记录",
      currentCount: "当前持仓单数 {n}",
      empty: "暂无持仓",
      historyEmpty: "暂无历史持仓"
    },
    position: {
      openPrice: "开仓价",
      closePrice: "平仓价",
      profitLoss: "盈亏",
      countdown: "距离结算",
      calculating: "计算中...",
      settled: "已结算",
      settling: "结算中",
      syncingTime: "同步时间中",
      active: "活跃",
      settledAt: "结算时间:",
      refunded: "已退款",
      won: "已盈利",
      lost: "已亏损"
    },
    modal: {
      amountPlaceholder: "请输入金额"
    },
    pairSelector: {
      title: "选择交易对",
      searchPlaceholder: "搜索币种",
      ordinary: "事件合约",
      ai: "AI 预测"
    },
    errors: {
      dataNotReady: "数据加载中，请稍候"
    },
    marketPause: {
      default: "市场暂不可交易，请稍后再试",
      lastPriceStreamWarming: "最新价行情准备中，请稍后再试",
      marketWarming: "市场预热中，请稍后再试",
      recovering: "行情恢复中，请稍后再试",
      clockNotSynced: "服务器时间未同步，请稍后再试",
      symbolUnavailable: "该交易对暂未开放"
    },
    toasts: {
      connectSuccess: "连接成功",
      connectCancelled: "您已取消连接",
      connectFailed: "连接失败"
    },
  },
  exchange: {
    title: "兑换",
    from: "从",
    to: "至",
    balance: "余额",
    all: "全部",
    placeholder: "请输入",
    fee: "手续费",
    minAmount: "最低兑换数量：{amount} {symbol}",
    button: "提交",
    tradeButton: "交易",
    paymentCurrency: "支付币种",
    estimatedGasFee: "预估Gas费用",
    gasPaymentNote: "将使用GetGas余额支付Gas费用",
    slippage: "滑点",
    auto: "自动",
    approximately: "约",
    minReceived: "Min 获得",
    exchangeRate: "兑换率",
    finalAmount: "最终获得金额",
    confirm: "确认",
    swapSuccess: "闪兑成功！",
    swapping: "闪兑中...",
    confirmTitle: "确认操作",
    confirmContent: "是否确认执行该操作？",
    rateHint: "{usdt} USDT = {joule} JOULE",
    rateHintPair: "{from} {fromSymbol} = {to} {toSymbol}",
    rateHintUsdtToJoule: "净到账以报价为准",
    rateHintJouleToUsdt: "含兑换费，净到账以报价为准",
    rateHintPantaFree: "暂免手续费，净到账以报价为准",
    feeZero: "手续费：0（暂免）",
    feeLabel: "手续费：{fee} {symbol}",
    grossLabel: "扣费前：{amount} {symbol}",
    netLabel: "净到账：{amount} {symbol}",
    pantaEffectivePrice: "PANTA 生效价：{price} U",
    pantaViaUsdtHint: "按 USDT 折算：{price} U/PANTA · 1 U = {joulePerUsdt} JOULE",
    quoting: "报价中…",
    configFee: "Joule → USDT 手续费 {fee}",
    configLimits: "手续费 {fee} · 扣费前价值限额 {min}–{max} U",
    unlimited: "不限",
    quoteFailed: "暂无法获取报价，请重试",
    toasts: {
      fetchFailed: "获取资产失败",
      enterValidAmount: "请输入有效金额",
      minAmount: "最低兑换数量为{amount} {symbol}",
      swapSuccess: "兑换成功",
      requestFailed: "请求失败",
      insufficientBalance: "余额不足，无法兑换",
      usdtRestricted: "USDT 资金审核中，暂不可兑换",
      quoteExpired: "报价已失效，请重新确认",
      amountStepInvalid: "兑换数量不符合步进要求，请调整后重试"
    }
  },
  globalNode: {
    title: "购买交易节点"
  },
  eventInsurance: {
    title: "事件合约保险",
    availableBalance: "可用余额",
    fundTransfer: "资金划转",
    lockedBalance: "不可划转",
    fundHistory: "保险资金记录",
    type: "类型:",
    all: "全部",
    transfer: "划转",
    insuranceDeduction: "保险扣费",
    insurancePayout: "保险赔付",
    fundTransferTitle: "保险资金划转",
    currency: "币种",
    from: "从",
    to: "到",
    availableAccount: "可用账户",
    contractAccount: "合约账户(TAKER)",
    contractInsuranceAccount: "合约保险账户",
    pleaseEnter: "请输入",
    confirmTransfer: "划转",
    insufficientBalance: "余额不足",
    transferSuccess: "资金划转成功！",
    transferFailed: "资金划转失败，请重试！",
    transferring: "资金划转中...",
    noRecords: "暂无记录",
    selectAccount: "选择账户",
    cannotTransferToSameAccount: "无法划转到同一账户",
    cannotTransferContractAccount: "暂不支持合约账户划转",
    equityTitle: "普通保险权益",
    personalEquity: "个人权益",
    teamEquity: "团队权益",
    equityNodes: "有效节点",
    premiumRules: "仓位阈值 {threshold}% · 低档保费 {low}% · 高档保费 {high}%（本单以预览为准）",
    remainingEquity: "剩余权益",
    peersPaid: "平级已付",
    peersPending: "平级待付",
    recentPayouts: "近期日结",
    creditsCount: "权益笔数",
    nodeBatches: "节点批次",
    peerRows: "待付平级笔数",
    rulesTab: "速览",
    agreementTab: "完整协议",
    insuranceRulesTitle: "保险规则",
    preview: {
      eventGroup: "一.事件合约预测规则协议",
      eventOpen: {
        title: "1. 保险开启",
        points: [
          "开启保险后将按下单金额与交易账户余额占比收取保费：下单金额不超过账户余额 10% 即收取 15% 保费；超过即收取 20%。",
          "若保险账户余额不足，保险不生效"
        ]
      },
      eventLimit: {
        title: "2. 下单阈值",
        points: [
          "单笔下单上限为 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. 赔付权益规则",
        ok: [
          "赔付金额的 50% 进入个人赔付空投额度，累计至 50 美金即获得一个算力节点",
          "赔付金额的 30% 进入社区赔付空投额度，按社区VIP等级规则分配，累计至 50 美金即获得一个算力节点"
        ],
        fail: [
          "失去全部下注本金，预测终止"
        ]
      },
      eventPool: {
        title: "4. 事件保险池赔付：",
        points: [
          "系统将按事件保险池每日资产总额 2% 的PANTA，用于所有合格用户算力节点加权平均空投",
          "用户获得事件保险池每日空投累计至 50 美金的PANTA时，即减少一个算力节点"
        ]
      },
      eventProfit: {
        title: "5. 盈亏规则",
        points: [
          "预测正确：用户获得“本金 100% + 盈利 (80%)”",
          "预测错误：失去全部下注本金，预测终止"
        ]
      },
      aiGroup: "二.AI事件合约预测规则协议",
      aiFirst: {
        title: "1. 首单需用户手动输入"
      },
      aiOpen: {
        title: "2. 保险开启",
        points: [
          "开启保险后，下单需要支付仓位金额 5%——10% 的金额作为保费",
          "若保险账户余额不足，保险不生效"
        ]
      },
      aiLimit: {
        title: "3. 下单限制",
        points: [
          "下单金额需严格按仓位表档位执行，且每次下注方向需要与AI预测方向一致",
          "若未按仓位表档位执行，即转为普通事件合约预测",
          "连续亏损 8 单，即可执行规定比例赔付权益",
          "若产生盈利订单，执行重置下单序列，即第1单"
        ]
      },
      table: {
        level: "账户等级",
        order1: "第1单",
        order2: "第2单",
        order3: "第3单",
        order4: "第4单",
        order5: "第5单",
        order6: "第6单",
        order7: "第7单",
        order8: "第8单"
      },
      claimOk: "符合赔付条件",
      claimFail: "不符合赔付条件",
      claimFailWhen: "不符合赔付条件时：",
      claimPrereq: "赔付前提：",
      aiClaim: {
        title: "4. 赔付权益机制",
        prereq: [
          "保险已开启",
          "下注与AI预测方向一致",
          "金额与仓位表档位顺序一致",
          "满足完整结算条件"
        ],
        ok: [
          "现金赔付 = 累计亏损金额 x 90%"
        ],
        fail: [
          "失去全部下注本金，预测终止"
        ]
      },
      aiProfit: {
        title: "5. 盈利规则",
        points: [
          "预测正确：用户获得“本金 100% + 盈利 80%”",
          "预测错误：失去全部下注本金，预测终止或按赔付权益赔付"
        ]
      }
    },
    rulesContent: "PANTA Market 事件合约交易保障计划保险协议\n\n【重要提示】使用本服务前，请务必仔细阅读并充分理解协议全部内容。系统将通过用户触发开启「保险开关」即视为您已充分阅读、理解并接受协议及附件内容，确认协议具有法律约束力，并同意严格遵守；若不同意且不接受，请立即停止使用其保障计划。\n\n第一条：协议总则与适用范围\n\n1.1 本协议用于说明 PANTA Market 内“事件合约预测”、“AI事件合约预测”两类功能的参与方式、订单成立、费用、结果判定、资金结算、条件性赔付及相关节点权益及事件预测功能。两类产品分别适用其专门条款，不能将其中一种产品的费率、赔付条件或节点规则直接套用到另一种产品。\n1.2 事件合约预测是用户对事先列明的事件及其可选结果作出判断，并使用 JOULE 提交且创建订单的功能。其最终合格亏损可按批准规则生成个人或社区团队节点额度；该额度不是即时现金赔付。AI事件合约预测是用户参考系统提供的有效AI预测方向信号，按照选定方案的固定金额和秩序逐笔确认参与创建订单的功能。同一合格序列的 8 笔订单完整结算且全部亏损，并同时满足其他明确条件时，按合格本金合计的90%计算 JOULE 赔付。AI信号不是结果保证，条件性赔付也不覆盖全部支出。\n1.3 本协议、对应产品的版本化参数、具体事件规则和用户确认页面应共同构成完整规则。页面只能展示已经批准的参数，不得用“以页面为准”替代关键条件的缺失。文件间发生矛盾时，应停止新增受影响交易并说明、核验和纠正，不得在事后单方选择对用户更不利的解释处理存量订单。\n1.4 本项目涉及真实资产、事件预测、条件性赔付及保险称谓、团队奖励、兑换和资金池，不属于可以省略风控合规评审的产品。各项功能的法律定性、许可、可提供地区、用户资格、反洗钱、消费者保护及数据处理要求，应按实际服务范围完成专业核验。免责声明不能替代必要许可、资金安排和控制措施；本稿不预设适用某一国家法律，也不认定产品已合法获准运营。\n\n第二条：术语与资金状态\n\n2.1 JOULE 是本产品设计中用于预测本金、保费及AI赔付计量的单位；PANTA 是节点权益分配等业务使用的资产单位；USDT 等值是部分额度和价值测算使用的计量口径。三者不能混用，内部数值展示不意味着可以按固定汇率即时兑换为法定货币，也不等于链上资产转移已经完成；该说明不取消已经依法依约形成的资产权益或支付义务。\n2.2 下单本金，是用户在某笔订单中实际确认并被系统接受的 JOULE 金额，不包括保费。保费，是按该笔订单适用规则计算的费用。冻结总额通常为本金与保费之和，另有费用时必须事前分别披露，不能在结算时追加未确认收费。\n2.3 可用余额，是在当前账户规则下可用于新增操作的余额。冻结余额，是已为接受的订单或批准的业务预留、暂不能用于其他操作的余额。预计收益、待审赔付、节点额度和未入账分配均不计入可用余额。余额展示应注明资产名称，不允许将不同资产数量直接相加。\n2.4 AI序列，是用户针对同一已确认方案，从第1笔开始按规则衔接的业务记录。当前步骤、订单结果和资格证据由服务端维护。正常断网或退出APP不构成序列业务终止；重置是符合本协议规定条件后终止旧序列。\n2.5 算力节点额度，是依据最终合格亏损按规则累计、用于生成节点的 USDT 等值记账单位。节点，是参与后续权益分配的资格记录，不是即时现金、已到账 PANTA，也不因名称而成为可交易、质押或自由转让的链上 NFT。\n2.6 规则快照，是订单或序列确认时保存的规则版本、参数、金额、价格依据、条款和相关证据。新版本发布不能覆盖旧快照。服务端记录用于核验操作状态，但用户可以提供其他证据申请复核，不能仅因记录由平台保存而排除合理异议。\n\n第三条：使用资格与确认协议\n\n3.1 平台仅可向已经批准的服务地区、年龄范围和适当性范围内的用户提供相应功能。正式版本应明确身份核验要求、产品可用范围及限制原因。不能仅凭用户钱包已连接、界面可见或账户有余额，认定其具备所有产品的参与资格。\n3.2 用户应使用本人有权控制的账户和资产，不得冒用身份、未经授权使用他人账户、伪造资格资料、操纵信号或结果证据。平台需要补充核验时，应说明所需资料与业务目的；对新参与的限制和既有订单的履约处理应分别说明。\n3.3 用户在下单前应能查阅本金、保费、可能的额外费用、预测选项、最坏损失、结算条件、判定来源和争议路径。平台应提供清晰的确认步骤，不应通过默认同意、隐藏费用、自动切换金额或催促重复操作代替用户的真实确认。\n3.4 AI信号、历史结果、示例收益、节点池规模及他人权益记录均不构成未来结果承诺。用户可能损失已接受订单的本金及相关保费，节点权益也可能受池余额、有效权重、价格和处理状态影响。用户不应把某个示例当作本人的固定收益或确定回收期限。\n\n第四条：事件合约预测规则\n\n4.1 用户开始AI序列前，应查看可用方案、执行仓位本金、预计保费、合计资金需求、信号有效期、60秒结算规则及90%赔付条件。新序列只能从第1笔开始，方案在序列进行中不得切换；用户不能用跳步、改额或并行未结订单组合为新的合格序列。 用户选择事件结果并输入 JOULE 本金后，平台依据已经批准的仓位基数计算保费。当前设计为：本金不超过仓位基数的10%时，保费为本金的15%；超过仓位基数的10%时，保费为本金的20%。恰好等于10%边界时适用15%。\n4.2 AI信号应显示标的、方向、时间、有效期和可识别的信号编号。用户下单时须确认与当时有效信号一致的方向。信号在等待或重连期间更新，应重新核验；过期信号不能被客户端缓存继续使用。采用AI信号不表示平台或算法知道未来结果。历史准确率、演示记录和预测解释不能作为本笔结果保证。平台不得用“保赢”“稳赚”或“错误也无损”等表达替代实际本金、保费和赔付条件。\n4.3 每个事件应独立列明名称、事实描述、可选结果、开放和封盘时点、时区、参与限额、结果判定标准、主要与备用证据来源、盈利计算、最坏损失、取消或延期规则及申诉安排。对模糊事件、缺失判定标准或关键经济参数未批准的事件，不得开放真实下单。平台应在接单时复核事件仍处于开放状态、服务端时间早于封盘时点、选项及版本有效、用户资格与限额满足、余额足够。封盘判断不以用户设备时间为准，也不以用户点击时客户端仍显示倒计时为准。\n4.4 本金及保费成功冻结、订单接受后，平台返回接受时间和约定结算时点。该时点按服务端接受时间加 60 秒计算，不从用户打开页面、收到信号或点击按钮时计算。网络延迟不会缩短或延长已经确定的判定口径。60秒表示约定的结果判定时点，不承诺在客户端倒计时归零的同一瞬间完成资金到账。到点后应获取约定来源的结果证据；无证据、来源异常或结果冲突时保持待结算并说明状态，不能自动记作亏损。\n4.5 只有在当前有效序列、规则已清楚展示、无未结订单的情况下，用户确实提交与有效信号不一致的方向或与当前固定步骤不一致的金额，才适用拒单并终止旧序列的重置设计。应展示具体原因、受影响序列及下一可执行操作，并保留原历史。重置后，下次可以从第1笔建立新序列，不能将旧序列已亏订单与新序列订单拼接计算8连亏。旧序列已完成的损益保留，不自动获得90%赔付；但不影响用户就平台错误、错误重置或其他争议申请复核。\n4.6 被拒绝的违规请求本身没有成交，不产生新增本金损失、保费或亏损节点。原材料中关于违规亏损转节点的表述尚未形成可执行规则，不能据此给拒单虚构亏损或补偿。\n4.7 用户暂停发起后续步骤，不等于已经形成8连亏；未完成序列不能请求按已亏笔数比例获得90%赔付。序列主动终止、长期停留和恢复期限尚需正式规则确认，不得自行增设一段未披露的失效时间。正常退出和断网不得解释为主动放弃。同一序列须同时满足以下四类条件，方可按当前设计计算90% JOULE 赔付：每笔保险机制有效开启且当单本金及保费实际冻结成功；每笔方向与接受时有效 AI 信号一致；每笔本金和步骤顺序符合已确认方案；8笔全部完整结算且结果全部为合格亏损，即可获取赔付。赔付金额为合格 8 笔参与本金合计乘90%，以 JOULE 计量并支付；保费不进入该 90% 基数。赔付不能直接表述为返还全部支出的 90%，也不自动折算为 USDT、现金或 PANTA。其他资产兑换仍需独立规则和授权。\n4.8 赔付资格成立与支付成功是两个阶段。具备资格但资金不足、账务异常或存在适用限制时，保留待支付义务和明细，显示处理中或明确的挂起原因，后续依法依约处理；不得把支付困难改写为用户不符合资格。\n4.9 赔付以该序列唯一记录执行一次。支付成功但响应丢失，后续查询和重试应返回原结果，不重复支付。支付失败应保持真实未完成状态，不要求用户新建序列或重新下单来“激活”原赔付。同一序列如依事先确认机制允许各笔采用不同费率，应逐笔保留快照并累计实际费用；不能简单使用某一个当前费率重算所有历史订单。影响已确认序列的费率机制变更，应先明确其适用范围，不可通过新页面追溯增加成本。\n4.10 资产最小单位、精度、逐笔舍入方法及尾差处理应在发布前确定并保持一致。页面为便于阅读的四舍五入不得改变账务明细；计算示例保留的精度不是已经批准的支付精度。手续费、价格差及尾差不得以合并显示方式隐藏。\n\n第五条：系统服务\n\n5.1 断网或请求超时：用户先查询原订单，平台返回已经接受、明确拒绝或仍待确认的实际状态。原结果未知时不得诱导重复付款；后续确认为未接受时，才按当前有效规则再次确认新请求。\n5.2 信号或报价过期：拒绝旧请求，显示原因并重新获取内容。不得静默替换为新方向、新金额或新费用，也不得将过期自动视为 AI 违规重置。若旧请求已经被接受，仍按其快照履行。\n5.3 结果或价格异常：暂停受影响判定、估值或分配，提供状态、受影响范围及查询渠道。缺失结果不能记失败亏损，异常估值不能用于扩大亏损基数。更换备用来源应遵守事先公布的来源顺序和异常规则。\n5.4 账务差异或外部交易状态未知：先核验原记录及外部回执，不重复发送不可逆动作。确认失败后按相应规则解冻或重试；未知不等于已退款。已完成的用户资金动作与未完成的后续购币、入池子步骤应分别展示。\n5.5 资金短缺：停止新增可能扩大缺口的相关业务、保留已形成义务、告知待处理状态，并按批准方案处理。不得伪造已到账、将用户可用余额改为负数或用未告知的额外收费填补差额。\n5.6 风险限制：平台可以依正式批准并适当披露的规则进行必要核验或限制，但应区分限制新单、延迟支付和取消资格。限制不得自动改写历史输赢或已满足的经济条件；适用例外应有事实与依据，并提供可用的复核渠道。\n5.7 维护、停止服务或关闭某产品时，历史订单、赔付、争议和可核对记录仍应有处理安排。用户不能新增交易不代表其已有余额、应付赔付或申诉权消失。关闭新业务开关不得顺带关闭全部历史查询和履约流程。\n\n第六条：免责条款\n\n以下情形引起的亏损，服务费不承担赔偿责任\n6.1 用户不遵守策略：任何偏离本平台标准仓位管理规定的行为\n6.2 极端市场条件：因交易所瘫痪、流动性枯竭、市场操纵引起的亏损\n6.3 系统与运营风险：因用户设备故障、操作失误、账户被盗等引起的亏损\n6.4 政策与合规风险：因法律、法规或监管命令变更导致的交易中断或禁止\n6.5 内在代币风险：JOULE市值大幅度下跌或崩溃，影响其作为保证金和结算货币功能\n6.6 欺诈与恶意行为：用户涉及欺诈、洗钱、市场操作或其他违法活动\n6.7 不可抗力：因不可抗力导致的本平台系统故障\n\n第七条：风险纰漏\n\n用户确认已充分理解并接受以下风险：\n7.1 不保本、不保利：本计划仅对部分亏损提供赔偿，绝对无法保证本金安全或盈利\n7.2 策略依赖风险：保障效果完全取决于对策略的严格遵守\n7.3 流动性与锁定风险：赔偿资金进入财富管理账户，可能涉及投资风险及锁定期，影响资金流动性\n7.4 第三方风险：所依赖的交易所存在运营、安全及价值波动风险\n7.5 监管不确定性风险：本平台面临全球监管不确定性及被叫停的风险\n7.6 技术安全风险：包括因智能合约漏洞、黑客攻击等导致的资产损失风险\n\n第八条：协议变更、终止与争议\n\n8.1 协议变更：本平台保留根据法律法规或运营需要修订本协议的权利，重大变更将通过平台公告通知\n8.2 协议终止：用户可随时关闭保障开关终止服务；若用户违反协议，平台可单方面终止；因法律或政策原因本计划可能终止用行\n8.3 争议解决：因本协议产生的争议应通过友好协商解决；协商不成功将提交至指定仲裁机构或法院解决\n\n【最终确认】您理解并同意「启用保险开关」是您确认受本协议全部内容约束的唯一且最终方式，请基于独立判断做出决定。"
  },
  walletBind: {
    connectWallet: "连接",
    inputPlaceholder: "输入地址",
    bind: "绑定",
    binding: "绑定中",
    tip: "提示：链接钱包出了问题，可尝试手动输入钱包地址绑定"
  },
  loginModal: {
    openWalletApp: "打开 {wallet}",
    openWalletConnect: "打开 {wallet} 连接",
    openWalletSign: "打开 {wallet} 签名",
    returnToBrowser: "完成后请返回本页继续",
    loginStepLabel: "第 {step}/2 步",
    stepConnectTitle: "连接钱包",
    stepConnectHint: "请在钱包中批准连接请求，完成后返回本页",
    stepConnectHintWithOpen: "点下方打开钱包并批准连接，完成后返回本页",
    stepSignTitle: "签名登录",
    stepSignHint: "请在钱包中签署登录消息（不会转出资产），完成后返回本页",
    stepSignHintWithOpen: "还需签名一步：点下方再次打开钱包签署登录消息",
    title: "登录 PANTA MARKET",
    connectWallet: "连接",
    connecting: "连接中...",
    alreadyConnected: "已连接",
    demoLogin: "演示登录（Mock）",
    tip: "提示: 链接钱包出了问题，可尝试手动输入钱包地址绑定",
    inputLabel: "输入钱包地址",
    inputPlaceholder: "0x234d456f6798...",
    bind: "绑定",
    binding: "绑定中",
    bindSuccess: "绑定成功",
    bindSuccessHint: "绑定成功，请重新登录",
    bindFailed: "绑定失败",
    noAuthCode: "缺少授权码",
    invalidAddress: "无效的钱包地址格式",
    confirmTitle: "确认绑定",
    confirmWarning: "请仔细确认以下地址是否为您的钱包地址，绑定后将无法修改",
    addressLabel: "钱包地址",
    cancel: "取消",
    confirm: "确认绑定",
    loginSuccess: "登录成功",
    connectFailed: "连接未完成，请重试",
    waitingWalletReturn: "等待钱包授权",
    waitingWalletHint: "请在钱包中确认，完成后请返回本页",
    waitingWalletHintShort: "若未自动跳转，请点下方打开钱包",
    retryLogin: "重试登录",
    networkRequired: "需要切换网络",
    networkRequiredHint: "请切换到 {chain}，返回本页后重试",
    switchingNetwork: "确认切换网络",
    switchingNetworkHint: "请在钱包中确认切换到 {chain}",
    signatureRequired: "请签名登录",
    signatureHint: "请在钱包中签名，不会转出资产",
    verifyingLogin: "正在验证",
    verifyingHint: "请稍候"
  },
  walletProfile: {
    title: "个人信息",
    address: "地址",
    accountName: "账号名称",
    inviteCode: "邀请码",
    deactivateAccount: "注销账号",
    logout: "退出登录",
    switchAccount: "登录其他账号",
    confirmLogout: "确定要退出登录吗？",
    loggingOut: "正在退出...",
    confirmSwitch: "确定要切换账号吗？当前账号将退出登录",
    developing: "功能开发中",
    addressCopied: "地址已复制",
    inviteCodeCopied: "邀请码已复制"
  },
  aiPrediction: {
    stakeAutofill: "AI 辅助",
    stakeAutofillWarning: "仅提供辅助，推荐金额可能出错，下单前请核对。网络延迟超过 800ms、检测失败或过期时暂停回填，恢复后自动继续。不影响手动下单。",
    stakeAutofillUnavailable: "网络不稳定或延迟超过 800ms，暂不能开启",
    stakeAutofillPaused: "网络不稳定，回填已暂停，可手动输入",
    insuranceSyncing: "正在同步保险仓位…",
    predictionBuffer: '预测准备中',
    scheduleResultPending: '本轮结果暂不可用，正在重试',
    recovery: {
      checking: '正在核实上次预测结果，不会重复扣次',
      pending: '上次预测仍在处理中，正在自动核实',
      unknown: '暂时无法确认上次结果。联网后自动核实，也可点击重试',
      released: '上次预测已取消或未生成结果，预占次数已释放',
      recovered: '已恢复上次预测结果，未重复扣次，下单截止时间不变',
      expired: '上次预测已生成并计次，但下单窗口已过期，不能重新下单',
      available: '已找回自主预测结果，正在等待时间同步或当前操作结束',
      bullish: '预测方向：看涨', bearish: '预测方向：看跌',
    },
    tierSelection: "AI保险档位",
    tierSaving: "正在确认档位，请勿重复操作",
    tierUnknown: "档位结果待确认，点击查询并重试",
    tierPending: "待应用档位（以服务端确认结果为准）",
    ordinaryPreviewHint: "当前金额不符合AI仓位，将按普通保险预览并确认",
    title: "AI预测",
    bookingTitle: "AI 场次预约",
    bookingExpand: "展开",
    bookingCollapse: "收起",
    bookingNextSystem: "系统下一场 · SGT",
    bookingNextMine: "我预约的下一场",
    bookingNone: "暂无",
    bookingStartingSoon: "已预约场次即将开始",
    bookingToday: "今天",
    bookingTomorrow: "明天",
    bookingTimezone: "SGT",
    bookingQuota: "剩余可参加 {remaining}/{dailyLimit} 场",
    bookingSeats: "{occupied}/{capacity} 人",
    bookingEmpty: "暂无可用场次",
    bookingWaiting: "请等待当前预测结束，结束后将自动入场",
    bookingEnded: "已结束",
    bookingJoin: "加入本场",
    bookingReserve: "预约",
    bookingJoined: "已入场",
    bookingReserved: "已预约",
    bookingFull: "已约满",
    bookingConfirm: "确认预约",
    bookingWarning: "预约成功即占用该日 1 次机会，未参加也计次。",
    bookingQuotaExhausted: "当日可参加场数已用完",
    bookingUnavailable: "当前不可预约",
    bookingFailed: "预约失败，请刷新后重试",
    countdown: "倒计时",
    expectedProfit: "预计盈利",
    active: "活跃",
    aiAnalysis: "AI智能涨跌概率分析",
    updateTime: "更新时间",
    probabilityUp: "买涨概率",
    probabilityDown: "买跌概率",
    startPrediction: "启动预测",
    startAIPrediction: "开启AI预测",
    scheduleConfirm: "跟随下单",
    scheduleBinding: "绑定信号中...",
    ruleScore: "规则评分 {score}，不是获胜概率",
    selectTier: "请选择保险档位",
    scheduleUnscheduled: "暂未安排",
    scheduleWaiting: "等待下一时段",
    schedulePreparing: "第 {round} 轮准备中",
    scheduleUnavailable: "当前不可下单",
    scheduleFinished: "本轮已结束",
    predicting: "预测中...",
    stayOnPageHint: "请勿离开当前页面，否则预测结果可能丢失",
    waitingResult: "等待结果",
    predictionResult: "预测结果",
    nextRound: "下一轮",
    aiPool: "AI保险池",
    orderWindowLabel: "下单剩余",
    eventContract: "事件合约",
    stakeFromStrategy: "仓位由策略指定",
    stakeTier: "档位 {tier}",
    stakeStep: "第 {step} 步",
    tierMatched: "已匹配{tier}档 · 第{step}/{total}步",
    tierBound: "当前{tier}档 · 第{step}/{total}步，本步要求 {amount} JOULE",
    tierBoundNoStake: "当前{tier}档 · 第{step}/{total}步",
    amountNotAi: "当前金额不符合AI保险要求",
    amountInvalid: "请输入至少 0.1 JOULE，最多 18 位小数",
    tierAmbiguous: "保险档位规则有歧义，暂不能开启",
    premiumEstimateAmount: "预计保费 {premium} JOULE",
    ordinaryInsuranceTitle: "本单为普通保险",
    ordinaryInsuranceBody: "本单为普通保险，不属于AI轮次赔付。确认后按预览保费提交。",
    sessionConflict: "已有进行中的AI保险轮次，请先恢复或结束后再下普通保险",
    conversionTitle: "确认转换为普通保险",
    conversionDesc: "本单将转为普通保险并结束本轮AI保险，此前累计AI连亏不赔付。普通保险保费 {premium} JOULE。",
    conversionConfirm: "确认转换并下单",
    orderSuccess: "AI预测下单成功！",
    orderFailed: "AI预测下单失败",
    orderConfirming: "正在确认 AI 预测下单结果，请勿重复操作",
    orderNotFilled: "本次 AI 预测下单未成交，未扣款",
    recoverTitle: "确认未完成 AI 预测订单",
    recoverContent: "检测到未确认 AI 预测订单（{symbol} {direction} {amount}）。将使用原幂等键确认，不会重复下单。",
    recoverConfirm: "确认订单",
    recoverCancel: "取消",
    userInfo: "用户信息",
    predictCount: "预测次数",
    freeCount: "免费预测次数",
    openTime: "开启时间: {time1}",
    up: "涨",
    down: "跌",
    rise: "买涨",
    fall: "买跌",
    notConnected: "未连接",
    count: "次数",
    learnMore: "了解更多",
    calculating: "计算中...",
    settled: "已结算",
    settling: "结算中",
    syncingTime: "同步时间中",
    settledAt: "结算时间:",
    refunded: "已退款",
    won: "已盈利",
    lost: "已亏损",
    position: {
      calculating: "计算中...",
      settled: "已结算",
      settling: "结算中",
      syncingTime: "同步时间中"
    },
    loginFirst: "请先登录",
    sessionSyncing: "正在同步",
    openPrice: "开仓价",
    closePrice: "平仓价",
    profitLoss: "盈亏",
    actions: {
      rise: "买涨",
      fall: "买跌"
    },
    holdings: {
      current: "当前持仓",
      history: "历史记录",
      aiHistory: "AI 历史记录",
      empty: "暂无持仓",
      historyEmpty: "暂无历史持仓",
      aiHistoryEmpty: "暂无 AI 历史记录"
    },
    buyModal: {
      title: "购买AI预测特权",
      description: "支付{amount}{symbol}即可获得{times}次额外AI预测次数。",
      upgradeAmount: "升级金额",
      balance: "当前可用余额",
      cancel: "取消购买",
      confirm: "确认购买",
      purchasing: "购买中...",
      purchaseSuccess: "购买成功",
      purchaseFailed: "购买失败",
      dailyLimit: "每日最多可购买1次。"
    },
    noPredictionAlert: {
      title: "AI预测开启失败",
      description: "您的AI预测次数为0，暂时不能使用AI预测功能，请购买后继续使用。",
      cancel: "取消购买",
      confirm: "确认购买"
    },
    toasts: {
      deferredWaitSettlement: "预测已生成，请等待当前持仓结算后再下单",
      insuranceCancelFailed: "关闭失败，可能有未结算订单",
      insuranceTierUnavailable: "请先选择保险档位",
      amountTierMismatch: "输入金额未匹配到保险档位",
      bindStakeChanged: "服务端要求的本金与输入不一致，已停止原下单",
      predictionFailed: "预测失败",
      predictionSuccess: "预测完成",
      premiumShortfallReminder: "整轮预计保费缺口约 {amount} JOULE（提醒，本单仍可按策略仓位提交）",
      requiredStakeInvalid: "预测仓位无效，请重新开启 AI 预测",
      resumeFailed: "恢复预测失败，请稍后重试",
      onlyBtcUsdt1m: "AI 预测仅支持 BTC、原油、黄金的 1 分钟模式",
      entryWindowExpired: "入场窗口已过期，请重新开启 AI 预测",
      scheduleRoundRequired: "请先同步当前轮次",
      scheduleNotReady: "结果尚未公布，请稍候",
      scheduleExpired: "本轮已截止，请等待下一轮",
      scheduleUnavailable: "定时预测暂不可用",
      unsettledConflict: "已有持仓未结算，请等待后再下单",
      orderWindowExpired: "下单时间已结束，请重新开启 AI 预测"
    },
    previousOrder: {
      title: "上一单",
      won: "已盈利",
      lost: "已亏损",
      refunded: "已退款",
      pending: "待结算",
      review: "核对中"
    },
    analyzing: "正在分析...",
    insurance: "保险",
    insuranceOn: "已生效",
    insuranceOff: "未生效",
    aiLabel: "AI",
    lookLong: "买涨",
    lookShort: "买跌",
    selfQuotaRemaining: "自主预测剩余次数：{remaining}/{limit}",
    followRoundProgress: "AI带单 · 第{current}/{total}轮",
    followRoundsCompleted: "AI带单已完成 · {current}/{total}",
    selfQuotaLoadingShort: "次数加载中",
    selfQuotaLoginHint: "登录后查看次数",
    selfQuotaLoading: "次数加载中，请稍后再试",
    selfQuotaExhausted: "今日免费自主预测次数已用完，付费预测暂未开放"
  },
  positionModal: {
    title: "涨幅预测",
    insurance: "保险",
    long: "买涨",
    short: "买跌",
    balance: "余额",
    available: "可用",
    loading: "加载中...",
    confirm: "确认",
    processing: "预测下单中...",
    success: "预测下单成功！",
    insuranceOn: "已开启",
    insuranceOff: "已关闭",
    aiLabel: "AI",
    lookLong: "买涨",
    lookShort: "买跌",
    operationFailed: "操作失败",
    balanceFetchFailed: "获取余额失败",
    minAmount: "最小金额为 0.1 JOULE",
    insufficientBalance: "余额不足，当前余额: {balance} JOULE",
    createFailed: "创建失败",
    recoverTitle: "恢复未确认订单",
    recoverContent: "检测到未确认下单（{symbol} {direction} {amount}）。将使用原幂等键恢复，不会重新报价。",
    recoverConfirm: "恢复订单",
    recoverCancel: "取消"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "新对话",
    manual: "操作手册",
    manualCardTitle: "查看操作手册",
    manualCardDesc: "充值、兑换、划转与 AI 预测完整图文步骤",
    hello: "你好，我是 AI 客服",
    hint: "可问行情分析、事件合约/AI 预测规则怎么看、团队与邀请入口，或风险提示。",
    placeholder: "问点什么...",
    send: "发送",
    thinking: "分析中...",
    disclaimer: "内容仅供参考，不构成投资建议。",
    bullish: "看涨",
    bearish: "看跌",
    aiAnalysis: "AI 智慧总结",
    strategy: "交易策略",
    reasoning: "推理分析",
    targetPrice: "目标价 {price}",
    stopLoss: "止损 {price}",
    takeProfit: "止盈 {price}",
    dirLong: "偏多",
    dirShort: "偏空",
    dirNeutral: "中性",
    analysisDone: "已完成 {symbol}（{timeframe}）分析，详见下方卡片。",
    analysisBtc: "已为你生成 BTC 短线分析。",
    analysisEth: "已为你生成 ETH 震荡分析。",
    analysisRisk: "以下是市场风险解读。",
    suggestions: {
      btc1m: "帮我分析 BTCUSDT 1 分钟短线走势",
      ethTrend: "ETH 现在适合追涨还是观望？",
      marketRisk: "当前市场风险偏好如何？要注意什么？",
      eventRules: "事件合约保险规则速览在哪看？",
      aiRules: "AI 预测规则和档位怎么理解？",
      teamWhere: "团队详情在哪里查看？",
      inviteWhere: "邀请链接和绑定上级在哪？"
    },
    guides: {
      eventRules: "事件合约保险规则：进入「事件合约」交易页，打开保险开关旁的规则入口，可看「速览」与「完整协议」。速览含开启保费、下单阈值、赔付权益与保险池等要点；完整协议为正式条款全文。",
      aiRules: "AI 预测：打开底部中间入口进入「AI 预测」。可查看下一轮倒计时、保险档位/步数、自主预测剩余次数。规则同样在保险规则弹窗的 AI 速览与完整协议中说明；下单需匹配档位金额与方向。",
      teamWhere: "团队详情：侧边栏或「我的」→「我的团队」，可切换交易收益/理财收益，点「团队明细」查看直推、流水、等级与成员；再点成员可下钻直推列表。",
      inviteWhere: "邀请与绑定：侧边栏/我的 →「邀请好友」可复制分享链接（含 ?ref=）。未绑定上级时登录后会弹出「绑定上级」；也可在邀请页手动填写。无邀请参数时输入框会预填环境变量中的默认上级地址。"
    },
    generic: {
      a: "已收到。可问行情、事件合约/AI 规则入口、团队与邀请位置，或点下方快捷问题。",
      b: "好的。我会给方向概率与策略要点，也可指路平台功能入口。",
      c: "收到。试试「事件合约规则」「AI 预测规则」「团队详情」「邀请链接」等快捷问题。"
    }
  },
  operationManual: {
    title: "操作手册",
    docTitle: "PANTA MARKET 操作手册",
    sourceHint: "图文步骤复刻自官方操作手册，可点击截图放大查看。"
  },
  pantaMarket: {
    comingSoon: '即将上线',
    title: "Panta Market",
    tokenSection: "PANTA协议治理代币",
    todayBurn: "今日销毁",
    totalBurn: "累计销毁",
    burned: "已销毁",
    initialSupply: "初始发行量",
    maxSupply: "最大发行量",
    finalCirculation: "最终流通量",
    contractAddress: "合约地址：",
    copied: "已复制",
    ecoSection: "PANTA · AI应用生态",
    ecoTabs: {
      market: "行情分析",
      arbitrage: "套利工具",
      acquisition: "全球获客",
      video: "视频创作"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA ·创意拼团",
    groupTabs: {
      recommend: "推荐",
      hot: "热门",
      ipDrama: "IP短剧",
      ipCollab: "IP共创",
      data: "数据"
    },
    filters: {
      all: "全部推荐",
      new: "新品首发",
      ending: "即将结束",
      highScore: "AI高分评价"
    },
    project: {
      badge: "星球首发",
      title: "《Panta AI · 崛起》AI动画短剧",
      score: "AI评分92",
      tagDrama: "IP短剧",
      tagRights: "确权项目#0001",
      desc: "Panta AI带我逆风翻盘，AI应用教学短剧"
    },
    values: {
      todayBurn: "321枚",
      totalBurn: "4212枚",
      initialSupply: "1000万枚",
      maxSupply: "2.1亿枚",
      finalCirculation: "2100万枚"
    }
  },
  copyTrade: {
    menuTitle: "跟单",
    pageTitle: "跟单",
    fallback: "操作失败，请稍后重试",
    pauseRule:
      "若本周结算完成时仍处于暂停，下周将自动取消跟单关系。",
    pauseSuccess: "暂停成功",
    resumeSuccess: "已恢复",
    endSuccess: "已结束",
    followSuccess: "跟单成功",
    pendingReviewToast: "待达人审核",
    savedSuccess: "已保存",
    registerSuccess: "注册成功，保证金已冻结",
    cancelRequested: "已申请注销",
    cancelWithdrawn: "已撤回注销",
    kickedSuccess: "已移出",
    approvedSuccess: "已通过",
    rejectedSuccess: "已拒绝",
    filledToForm: "已填入跟单表单",
    traderNotFound: {
      search: "该地址不是达人",
      business: "该达人暂不可用",
    },
    tabs: {
      board: "排行榜",
      follows: "我的跟单",
      join: "去跟单",
      trader: "带单",
      apps: "申请",
      fans: "跟随者",
      rules: "规则",
      settings: "规则",
      follow: "去跟单",
    },
    ui: {
      refresh: "刷新",
      search: "搜索",
      loginWallet: "登录钱包",
      needLoginAction: "该操作需要钱包登录，与下单相同。",
      needLoginTrader: "达人相关接口需要登录。",
      loginToView: "登录后可查看",
      loading: "加载中…",
      empty: "暂无",
      readonly: "只读",
      yes: "是",
      no: "否",
      immediate: "立即生效",
      current: "当前",
      nextWeek: "下周",
      pause: "暂停",
      resume: "恢复",
      end: "结束",
      save: "保存",
      kick: "踢出",
      approve: "通过",
      reject: "拒绝",
      requestCancel: "申请注销",
      withdrawCancel: "撤回注销",
      confirmFollow: "确认跟单",
      registerWithDeposit: "冻结保证金并注册",
      registerConfirmTitle: "确认注册",
      registerFreezeConfirm: "交易账户将冻结{amount}JOULE保证金。",
      platformSettings: "平台配置",
      settingsTip:
        "只复制普通模式且已开启保险的带单订单。未投保的普通单和 AI 单不会跟，跟随生成的 COPY 单也不会再带单。达人请用现有下单接口，不要传 orderSource。跟单者在订单列表能看到 COPY 单。金额只显示两位小数，多出来的直接截掉。",
      deposit: "保证金",
      depositFreezeWeeks: "保证金冻结周数",
      maxFollowers: "人数上限",
      shareRateRange: "分润区间",
      shareRateDefault: "默认分润",
      shareRateNextWeek: "分润下周生效",
      pendingShareHint: "下周一生效：{rate}",
      pendingMaxFollowersHint: "下周一生效：{n}",
      depositFrozenShort: "仍冻结",
      minFollowStake: "最低跟单本金",
      ratioRange: "等比区间",
      maxSimultaneousFollows: "同时跟达人数",
      defaultReview: "默认审核",
      defaultMinBalance: "默认余额门槛",
      settlementTimezone: "结算时区",
      leaderboardMeta: "榜单门槛/条数",
      leaderboardMetaValue: "{min} 场 / {size} 条",
      weekLeaderboard: "本周胜率榜",
      expertLeaderboard: "达人排行榜",
      heroTitle: "成为实力达人",
      heroDesc: "开启您的带单交易，赚取收益分润",
      heroActiveTitle: "已成为实力达人",
      heroActiveDesc: "您已开启跟单交易身份，带单进行中",
      heroRegister: "注册达人",
      heroSettings: "带单设置",
      myLeading: "我的带单",
      winRateBoard: "胜率榜",
      pnlBoard: "盈利榜",
      searchAddress: "搜索地址",
      searchNicknameOrAddress: "搜索昵称或地址",
      searchQueryTooShort: "请至少输入 2 个字符",
      winRateShort: "胜率",
      followersLabel: "跟单人数:",
      shareRateLabel: "分润比例:",
      roundPnlLabel: "本轮盈亏:",
      settledOrders: "已结 {n} 场",
      activeCount: "进行中",
      followStatsShort: "分润池 {pool} · 暂存 {cash}",
      traderSettings: "带单设置",
      confirmChanges: "确认修改",
      confirmCancel: "确认注销",
      cancelModalTitle: "注销说明",
      activeInProgress: "全部进行中",
      leadingFollowerCount: "跟单人数 {n}",
      auditApps: "审核申请 {n}",
      leaderboardNote:
        "只统计本周、普通来源且已投保的已赢／已输订单，达到最低场次才上榜。不是全历史胜率，也不是 AI 胜率。没有团队名称和累计跟单额。",
      weekStart: "周起始（周一）：{date}",
      leaderboardEmpty: "暂无上榜达人，可搜索完整地址跟单",
      winRate: "胜率 {n}%",
      boardSub:
        "分润 {share} · 跟单 {followers}/{max} · 已结 {orders} 场 · 本周盈亏 {pnl} JOULE",
      searchTrader: "搜索达人",
      walletPlaceholder: "完整钱包地址 0x…",
      address: "地址",
      status: "状态",
      shareRate: "分润",
      review: "审核",
      minBalance: "余额门槛",
      followerCount: "人数",
      startFollow: "发起跟单",
      traderWallet: "达人地址",
      followMode: "跟单方式",
      ratioLabel: "等比（%），区间 {min} ~ {max}",
      insuranceMode: "保险策略",
      takeProfit: "止盈（JOULE，可选）",
      stopLoss: "止损（JOULE，可选）",
      takeProfitPh: "本周净盈亏达标后暂停",
      stopLossPh: "本周净亏损达标后暂停",
      followHint:
        "每位用户同时最多可跟随 {n} 位达人。达到上限后发起新跟单时，系统将先行终止既有跟单关系；该操作即时生效，并非预览。跟单参数不可单独修改；如需调整，请先结束当前关系后再重新跟单。",
      endConfirm:
        "确认结束与该达人的跟单关系？结束后将不再跟随其交易信号；历史订单及已结算盈亏不受影响。",
      weeklyPoolHint: "分润池是本周池子，不是累计跟单金额。已结束关系和待审核申请不在这份列表里。",
      networkUnclear:
        "结果未确认。请先刷新查看当前关系或达人身份，确认没有成功后再重试。",
      myFollows: "我的跟单",
      noFollows: "暂无跟单关系",
      followSub:
        "{mode}{ratio} · {insurance} · 本周锁定分润 {share}",
      followStats:
        "本周净盈亏 {pnl} · 分润池 {pool} · 暂存 {cash}",
      pauseReason: "暂停原因：{reason}",
      registerTrader: "注册达人",
      registerHint:
        "注册条件：需一次性缴纳 {amount} JOULE 作为带单保证金，带单期间保证金持续冻结，注销身份后审核退回。一个钱包地址只能注册一个达人身份！",
      registerBalanceHint:
        "冻结保证金 {deposit} JOULE 后，账户可用余额仍须 ≥ {remain} JOULE 才能完成注册。",
      shareRateInput:
        "分润比例（%）区间 {min} ~ {max}，修改后下一周期生效。",
      maxFollowersInput: "跟单上限（≤ {max}）",
      reviewMode: "通过方式",
      minBalanceInput: "跟单用户余额门槛 · 可选（JOULE）",
      myTrader: "我的达人身份",
      depositHeld: "{amount} / 冻结 {held}",
      currentFollowers: "当前跟单人数",
      cancelEffective: "注销生效",
      depositRelease: "保证金退回",
      editParams: "修改参数",
      editHint:
        "分润/人数写入下周生效；审核与门槛立即生效。结算限制窗口为新加坡时间周日 22:00 至周一 01:00 前，以服务端为准，不要在周一 0:00 自行恢复修改。",
      shareRatePercent: "分润比例（%）",
      minBalanceJoule: "余额门槛（JOULE）",
      cancelTip:
        "注销后本周仍带单，下周一 0:00 身份失效；保证金再冻一整周后退回。失效前可撤回。",
      followers: "跟单用户",
      followerSub: "{mode}{ratio} · 本周盈亏 {pnl} · 暂存 {cash}",
      applications: "待审核",
      noApplications: "暂无申请",
      fillForm: "填入跟单表单",
      needTraderFirst: "请先注册带单身份",
      cancelRequestedAt: "申请注销时间",
      ratioRangeInvalid: "等比需在 {min} ~ {max} 之间",
      shareRangeInvalid: "分润需在 {min} ~ {max} 之间",
      maxFollowersInvalid: "人数上限不能超过 {max}",
      needShareRate: "请填写分润比例",
      needMaxFollowers: "请填写人数上限",
      needRatio: "请填写等比比例",
      badTakeProfit: "止盈金额不正确",
      badStopLoss: "止损金额不正确",
      badMinBalance: "余额门槛不正确",
      insuranceShortFollow: "跟随",
      insuranceShortOn: "常开",
      insuranceShortOff: "常关",
      symbolSettings: "跟单选项设置",
      symbolPickHint: "初始默认全部关闭，需手动开启，可随时修改",
      followSymbolHint: "只能从该达人已开放的币种里选择，至少开启一个。",
      followSymbolWait: "请先搜索达人，再选择要跟随的币种。",
      symbolNeedOne: "请至少开启一个币种",
      symbolNotAllowed: "所选币种不在达人允许范围内",
      effectiveSymbols: "实际跟随",
      editSymbols: "修改币种",
      allowedSymbols: "开放币种",
      weekPnlLabel: "本周盈亏:",
      currentNetPnlLabel: "当前净盈亏",
      categoryCrypto: "加密货币",
      categoryCommodity: "大宗商品",
      categoryEquity: "股票",
      symbolListCol: "列表",
      symbolLeadCol: "是否带单",
      symbolFollowCol: "是否跟单",
      symbolTags: "开放",
      leadingSymbols: "带单信息",
      detail: "明细",
      enabled: "开启",
      disabled: "关闭",
      held: "已持仓",
      notHeld: "未持仓",
      weekSettledOrders: "本轮已结场",
      historicalNetPnl: "历史总盈亏",
      copyTotalPnl: "跟单总盈亏",
      historicalSharePayout: "历史分润总额",
      allOrders: "全部",
      openOrders: "进行中",
      settledOrdersTab: "已完成",
      prevPage: "上一页",
      nextPage: "下一页",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "跳至",
      jumpConfirm: "确定",
      colInterval: "时长",
      colOrderTime: "下单时间",
      colSelfPnl: "自身盈亏(含保费)",
      colEstShare: "预估分润",
      traderOrdersTitle: "{symbol} 带单明细",
      followOrdersTitle: "{symbol} 跟单明细",
      selfPnl: "自身盈亏",
      estimatedShare: "预估分成",
      inProgress: "进行中",
      followAssets: "按资产盈亏",
      byAsset: "按资产",
      followHistory: "已结束",
      followStartTime: "开始时间：",
      followEndTime: "结束时间：",
      myPendingApps: "待审核",
      cashHeldHint: "本轮预估待扣分润 {cash} JOULE",
      cashHeldFrozen: "本轮当前预估扣除分润：{cash}（JOULE，已冻结）",
      followedTrader: "跟单达人",
      followInfo: "跟单信息",
      totalPnlJoule: "总盈亏 (JOULE)",
      colTrader: "达人",
      colPrincipal: "本金",
      colPnlShare: "盈亏(含保费)/分润(JOULE)",
      traderInfo: "达人信息",
      traderNotFound: "该地址不是达人",
      followSettingsRelationHint:
        "跟单方式、保险策略与止盈止损为整段关系一份配置，对当前勾选的全部币种一并生效。可随时在「跟单设置」中修改。",
      followSettingsPrepareHint: "确认后，对勾选的币种使用同一套跟单配置发起跟单。",
      followOptions: "跟单选项",
      noFollowOptions: "暂无跟单选项~",
      symbolFollowing: "已跟单",
      symbolPaused: "已暂停",
      symbolIdle: "未跟",
      cancelFollowSymbol: "取消跟单",
      cancelSymbolConfirm: "取消跟随 {symbol}？",
      cancelLastSymbolConfirm: "这是最后一个跟随币种，取消后将结束整段跟单关系。确认？",
      followNow: "立即跟单",
      followAll: "跟单",
      unfollowAll: "解除跟单",
      unfollowAllConfirm: "确认取消跟随该达人的全部交易对？结束后将解除整段跟单关系。",
      followSettings: "跟单设置",
      goFollowSettings: "前往 ›",
      copyAccountBalance: "跟单账户：{amount} JOULE",
      orderFollowerCount: "跟单人数",
      copyingStatus: "跟单中",
      roleStatusLeading: "带单中",
      roleStatusFollowing: "跟单中",
      roleStatusPaused: "跟单已暂停",
      copyOrderTag: "跟单",
      copyOpenPositions: "当前跟单持仓",
      copyInsuredOrdinary: "已持普通保险",
      copyUninsured: "未投保",
      addSymbolHint: "将把该币种加入当前跟单关系。",
      myRelationStatus: "我的跟单",
      latestSettlements: "最新结算",
      resumeRelationFirst: "关系已整段暂停，请先在「我的跟单」恢复后再按币种操作",
      resumeStopLossHint: "目前已亏损 {amount}，请将止损金额设置在 {amount} 以上以继续跟单",
      resumeTakeProfitHint: "目前已盈利 {amount}，请将止盈金额设置在 {amount} 以上以继续跟单",
      resumeStartFollow: "开始跟单",
      colType: "类型",
      colPnlJoule: "盈亏 (JOULE)",
      tpSl: "止盈止损",
      takeProfitPhFull: "本轮净盈利达到后暂停跟单 - 可选（JOULE）",
      stopLossPhFull: "本轮净亏损达到后暂停跟单 - 可选（JOULE）",
      confirmModify: "确认修改",
      clearSearch: "返回榜单",
      searchResultHint: "搜索结果（点击进入达人信息）",
      searchEmpty: "该地址不是达人",
      noMoreSettlements: "没有更多了",
    },
    errors: {
      AUTH_REQUIRED: "请先登录钱包",
      AUTH_UNAVAILABLE: "登录服务暂不可用，请稍后重试",
      POSTGRES_REQUIRED: "服务暂不可用，请稍后重试",
      USER_NOT_FOUND: "用户不存在，请重新登录后再试",
      INVALID_WALLET: "请输入完整的钱包地址",
      INVALID_QUERY: "搜索关键词无效，请至少输入 2 个字符",
      INVALID_AMOUNT: "金额格式不正确",
      INVALID_PARAM: "参数不合法，请检查后重试",
      INVALID_FOLLOW: "不能跟自己的单",
      TRADER_EXISTS: "该钱包已是达人，无需重复注册",
      TRADER_FULL: "该达人跟单人数已满",
      TRADER_CANCELLED: "该达人身份已注销",
      TRADER_REGISTER_FAILED: "注册达人失败，请稍后重试",
      TRADER_SETTINGS_FAILED: "保存达人设置失败，请稍后重试",
      NOT_A_TRADER: "请先注册达人身份",
      TRADER_UNAVAILABLE: "该达人暂不可用",
      INSUFFICIENT_BALANCE: "可用余额不足，无法冻结保证金",
      BALANCE_TOO_LOW: "跟单账户可用余额未达到该达人门槛，请先从交易账户划转",
      COPY_BALANCE_ZERO: "跟单账户余额为 0，请先从交易账户划转",
      INSUFFICIENT_FUNDS: "交易账户余额不足，无法划入跟单账户",
      COPY_TRADE_BALANCE_INSUFFICIENT: "跟单账户可用不足（冻结本金/分润不可划出）",
      ACCOUNT_NOT_FOUND: "账户异常，请稍后重试",
      ACCOUNT_CONFLICT: "账户正在变动，请稍后重试",
      FOLLOW_EXISTS: "你已在跟该达人",
      FOLLOW_LIMIT: "你已有进行中的跟单，请先结束后再跟其他达人",
      FOLLOW_FAILED: "发起跟单失败，请稍后重试",
      FOLLOW_NOT_FOUND: "跟单关系不存在或不属于当前用户",
      PAUSE_FAILED: "暂停跟单失败，请稍后重试",
      RESUME_FAILED: "恢复跟单失败，请稍后重试",
      STOP_LOSS_THRESHOLD: "止损金额仍不够高，请调高或清空后再恢复",
      TAKE_PROFIT_THRESHOLD: "止盈金额仍不够高，请调高或清空后再恢复",
      END_FAILED: "结束跟单失败，请稍后重试",
      APPLICATION_NOT_FOUND: "待审申请不存在或不属于当前用户",
      APPROVE_FAILED: "审核通过失败，请稍后重试",
      REJECT_FAILED: "拒绝申请失败，请稍后重试",
      KICK_FAILED: "移出跟单用户失败，请稍后重试",
      SETTLEMENT_WINDOW: "结算窗口内暂不可修改达人参数",
      CANCEL_FAILED: "申请注销失败，请稍后重试",
      CANCEL_NOT_PENDING: "当前没有可撤回的注销申请",
      CANCEL_WITHDRAW_FAILED: "撤回注销失败，请稍后重试",
      COPY_SETTINGS_MISSING: "跟单配置未就绪，请稍后重试",
      INVALID_SYMBOL: "请选择至少一个支持的币种",
      SYMBOL_NOT_ALLOWED: "包含达人未开放的币种",
      TRADER_BALANCE_TOO_LOW: "冻完保证金后可用余额不足，无法注册达人",
      TIMEOUT: "操作失败，请稍后重试",
      NETWORK: "操作失败，请稍后重试",
    },
    status: {
      ACTIVE: "跟单中",
      PAUSED: "已暂停",
      ENDED: "已结束",
      PENDING_REVIEW: "待达人审核",
      CANCEL_PENDING: "注销中",
      CANCELLED: "已注销",
    },
    traderStatus: {
      ACTIVE: "带单中",
      CANCEL_PENDING: "退出中",
      CANCELLED: "已取消",
    },
    pauseReason: {
      USER: "用户暂停",
      INSUFFICIENT_BALANCE: "跟单账户余额不足已暂停",
      TAKE_PROFIT: "止盈触发",
      STOP_LOSS: "止损触发",
      TRADER_KICK: "达人移出",
      SWITCH: "已更换达人",
      SETTLEMENT_CLEANUP: "周结算自动移除",
      TRADER_CANCEL: "达人注销",
    },
    followMode: {
      EQUAL: "等额",
      RATIO: "等比",
    },
    insuranceMode: {
      FOLLOW: "跟随达人",
      ALWAYS_ON: "常开保险",
      ALWAYS_OFF: "常关保险",
    },
    reviewMode: {
      AUTO: "自动跟单",
      MANUAL: "审核跟单",
    },
    applicationStatus: {
      PENDING: "待审核",
      APPROVED: "已通过",
      REJECTED: "已拒绝",
      CANCELLED: "已取消",
      PENDING_REVIEW: "待审核",
    },
  },
}
